// Copied from react-native-vector-icons/glyphmaps/FontAwesome6Pro.json
const FontAwesomeGlyphs = {
  '0': 48,
  '1': 49,
  '2': 50,
  '3': 51,
  '4': 52,
  '5': 53,
  '6': 54,
  '7': 55,
  '8': 56,
  '9': 57,
  '100': 58396,
  'fill-drip': 62838,
  'arrows-to-circle': 58557,
  'circle-chevron-right': 61752,
  'chevron-circle-right': 61752,
  'wagon-covered': 63726,
  'line-height': 63601,
  bagel: 58327,
  'transporter-7': 58024,
  at: 64,
  'rectangles-mixed': 58147,
  'phone-arrow-up-right': 57892,
  'phone-arrow-up': 57892,
  'phone-outgoing': 57892,
  'trash-can': 62189,
  'trash-alt': 62189,
  'circle-l': 57620,
  'head-side-goggles': 63210,
  'head-vr': 63210,
  'text-height': 61492,
  'user-xmark': 62005,
  'user-times': 62005,
  'face-hand-yawn': 58233,
  'gauge-simple-min': 63021,
  'tachometer-slowest': 63021,
  stethoscope: 61681,
  coffin: 63174,
  message: 62074,
  'comment-alt': 62074,
  salad: 63518,
  'bowl-salad': 63518,
  info: 61737,
  'robot-astromech': 58066,
  'ring-diamond': 58795,
  'fondue-pot': 58381,
  theta: 63134,
  'face-hand-peeking': 58497,
  'square-user': 57987,
  'down-left-and-up-right-to-center': 62498,
  'compress-alt': 62498,
  explosion: 58601,
  'file-lines': 61788,
  'file-alt': 61788,
  'file-text': 61788,
  'wave-square': 63550,
  ring: 63243,
  'building-un': 58585,
  'dice-three': 62759,
  'tire-pressure-warning': 63027,
  'wifi-fair': 63147,
  'wifi-2': 63147,
  'calendar-days': 61555,
  'calendar-alt': 61555,
  'mp3-player': 63694,
  'anchor-circle-check': 58538,
  'tally-4': 58007,
  'rectangle-history': 58530,
  'building-circle-arrow-right': 58577,
  volleyball: 62559,
  'volleyball-ball': 62559,
  'sun-haze': 63333,
  'text-size': 63636,
  ufo: 57415,
  fork: 62179,
  'utensil-fork': 62179,
  'arrows-up-to-line': 58562,
  'mobile-signal': 57839,
  'barcode-scan': 62565,
  'sort-down': 61661,
  'sort-desc': 61661,
  'folder-arrow-down': 57427,
  'folder-download': 57427,
  'circle-minus': 61526,
  'minus-circle': 61526,
  'face-icicles': 58236,
  shovel: 63251,
  'door-open': 62763,
  films: 57722,
  'right-from-bracket': 62197,
  'sign-out-alt': 62197,
  'face-glasses': 58231,
  nfc: 57847,
  atom: 62930,
  soap: 57454,
  icons: 63597,
  'heart-music-camera-bolt': 63597,
  'microphone-lines-slash': 62777,
  'microphone-alt-slash': 62777,
  'closed-captioning-slash': 57653,
  'calculator-simple': 63052,
  'calculator-alt': 63052,
  'bridge-circle-check': 58569,
  'sliders-up': 62449,
  'sliders-v': 62449,
  'location-minus': 62985,
  'map-marker-minus': 62985,
  'pump-medical': 57450,
  fingerprint: 62839,
  'ski-boot': 58316,
  'standard-definition': 57994,
  'rectangle-sd': 57994,
  h1: 62227,
  'hand-point-right': 61604,
  'magnifying-glass-location': 63113,
  'search-location': 63113,
  'message-bot': 58296,
  'forward-step': 61521,
  'step-forward': 61521,
  'face-smile-beam': 62904,
  'smile-beam': 62904,
  'light-ceiling': 57366,
  'message-exclamation': 62629,
  'comment-alt-exclamation': 62629,
  'bowl-scoop': 58334,
  'bowl-shaved-ice': 58334,
  'square-x': 57990,
  'utility-pole-double': 58052,
  'flag-checkered': 61726,
  'chevrons-up': 62245,
  'chevron-double-up': 62245,
  football: 62542,
  'football-ball': 62542,
  'user-vneck': 58465,
  'school-circle-exclamation': 58732,
  crop: 61733,
  'angles-down': 61699,
  'angle-double-down': 61699,
  'users-rectangle': 58772,
  'people-roof': 58679,
  'square-arrow-right': 62267,
  'arrow-square-right': 62267,
  'location-plus': 62986,
  'map-marker-plus': 62986,
  'lightbulb-exclamation-on': 57802,
  'people-line': 58676,
  'beer-mug-empty': 61692,
  beer: 61692,
  'crate-empty': 57681,
  'diagram-predecessor': 58487,
  transporter: 57410,
  'calendar-circle-user': 58481,
  'arrow-up-long': 61814,
  'long-arrow-up': 61814,
  'person-carry-box': 62671,
  'person-carry': 62671,
  'fire-flame-simple': 62570,
  burn: 62570,
  person: 61827,
  male: 61827,
  laptop: 61705,
  'file-csv': 63197,
  menorah: 63094,
  union: 63138,
  'chevrons-left': 62243,
  'chevron-double-left': 62243,
  'circle-heart': 62663,
  'heart-circle': 62663,
  'truck-plane': 58767,
  'record-vinyl': 63705,
  'bring-forward': 63574,
  'square-p': 57977,
  'face-grin-stars': 62855,
  'grin-stars': 62855,
  sigma: 63115,
  'camera-movie': 63657,
  bong: 62812,
  clarinet: 63661,
  'truck-flatbed': 58038,
  'spaghetti-monster-flying': 63099,
  pastafarianism: 63099,
  'arrow-down-up-across-line': 58543,
  'leaf-heart': 62667,
  'house-building': 57777,
  'cheese-swiss': 63472,
  spoon: 62181,
  'utensil-spoon': 62181,
  'jar-wheat': 58647,
  'envelopes-bulk': 63092,
  'mail-bulk': 63092,
  'file-circle-exclamation': 58603,
  'bow-arrow': 63161,
  'cart-xmark': 57565,
  'hexagon-xmark': 62190,
  'times-hexagon': 62190,
  'xmark-hexagon': 62190,
  'circle-h': 62590,
  'hospital-symbol': 62590,
  merge: 58662,
  pager: 63509,
  'cart-minus': 57563,
  'address-book': 62137,
  'contact-book': 62137,
  'pan-frying': 58412,
  grid: 57749,
  'grid-3': 57749,
  'football-helmet': 62543,
  'hand-love': 57765,
  trees: 63268,
  strikethrough: 61644,
  page: 58408,
  k: 75,
  'diagram-previous': 58488,
  'gauge-min': 63016,
  'tachometer-alt-slowest': 63016,
  'folder-grid': 57736,
  eggplant: 57708,
  ram: 63242,
  'landmark-flag': 58652,
  lips: 62976,
  pencil: 62211,
  'pencil-alt': 62211,
  backward: 61514,
  'caret-right': 61658,
  comments: 61574,
  paste: 61674,
  'file-clipboard': 61674,
  'desktop-arrow-down': 57685,
  'code-pull-request': 57660,
  pumpkin: 63239,
  'clipboard-list': 62573,
  'pen-field': 57873,
  blueberries: 58088,
  'truck-ramp-box': 62686,
  'truck-loading': 62686,
  note: 57855,
  'arrow-down-to-square': 57494,
  'user-check': 62716,
  'cloud-xmark': 58207,
  'vial-virus': 58775,
  'book-blank': 62937,
  'book-alt': 62937,
  'golf-flag-hole': 58284,
  'message-arrow-down': 57819,
  'comment-alt-arrow-down': 57819,
  'face-unamused': 58271,
  'sheet-plastic': 58737,
  'circle-9': 57590,
  blog: 63361,
  'user-ninja': 62724,
  'pencil-slash': 57877,
  'bowling-pins': 62519,
  'person-arrow-up-from-line': 58681,
  'down-right': 57707,
  'scroll-torah': 63136,
  torah: 63136,
  'blinds-open': 63740,
  fence: 58115,
  up: 62295,
  'arrow-alt-up': 62295,
  'broom-ball': 62552,
  quidditch: 62552,
  'quidditch-broom-ball': 62552,
  drumstick: 63190,
  'square-v': 57988,
  'face-awesome': 58377,
  'gave-dandy': 58377,
  'dial-off': 57698,
  'toggle-off': 61956,
  'face-smile-horns': 58257,
  'box-archive': 61831,
  archive: 61831,
  grapes: 58118,
  'person-drowning': 58693,
  'dial-max': 57694,
  'circle-m': 57621,
  'calendar-image': 57556,
  'circle-caret-down': 62253,
  'caret-circle-down': 62253,
  'arrow-down-9-1': 63622,
  'sort-numeric-desc': 63622,
  'sort-numeric-down-alt': 63622,
  'face-grin-tongue-squint': 62858,
  'grin-tongue-squint': 62858,
  'shish-kebab': 63521,
  'spray-can': 62909,
  'alarm-snooze': 63557,
  scarecrow: 63245,
  'truck-monster': 63035,
  'gift-card': 63075,
  w: 87,
  'code-pull-request-draft': 58362,
  'square-b': 57956,
  elephant: 63194,
  'earth-africa': 62844,
  'globe-africa': 62844,
  rainbow: 63323,
  'circle-notch': 61902,
  'tablet-screen-button': 62458,
  'tablet-alt': 62458,
  paw: 61872,
  'message-question': 57827,
  cloud: 61634,
  'trowel-bricks': 58762,
  'square-3': 57944,
  'face-flushed': 62841,
  flushed: 62841,
  'hospital-user': 63501,
  microwave: 57371,
  'tent-arrow-left-right': 58751,
  'cart-circle-arrow-up': 58352,
  'trash-clock': 58032,
  gavel: 61667,
  legal: 61667,
  'sprinkler-ceiling': 58444,
  browsers: 57547,
  trillium: 58760,
  'music-slash': 63697,
  'truck-ramp': 62688,
  binoculars: 61925,
  'microphone-slash': 61745,
  'box-tissue': 57435,
  'circle-c': 57601,
  'star-christmas': 63444,
  'chart-bullet': 57569,
  motorcycle: 61980,
  'tree-christmas': 63451,
  'tire-flat': 63026,
  sunglasses: 63634,
  badge: 62261,
  'message-pen': 62628,
  'comment-alt-edit': 62628,
  'message-edit': 62628,
  'bell-concierge': 62818,
  'concierge-bell': 62818,
  'pen-ruler': 62894,
  'pencil-ruler': 62894,
  'chess-rook-piece': 62536,
  'chess-rook-alt': 62536,
  'square-root': 63127,
  'album-collection-circle-plus': 58510,
  'people-arrows': 57448,
  'people-arrows-left-right': 57448,
  'face-angry-horns': 58216,
  'mars-and-venus-burst': 58659,
  tombstone: 63264,
  'square-caret-right': 61778,
  'caret-square-right': 61778,
  scissors: 61636,
  cut: 61636,
  'list-music': 63689,
  'sun-plant-wilt': 58746,
  'toilets-portable': 58756,
  'hockey-puck': 62547,
  mustache: 58812,
  hyphen: 45,
  table: 61646,
  'user-chef': 58322,
  'message-image': 57824,
  'comment-alt-image': 57824,
  'users-medical': 63536,
  'sensor-triangle-exclamation': 57385,
  'sensor-alert': 57385,
  'magnifying-glass-arrow-right': 58657,
  'tachograph-digital': 62822,
  'digital-tachograph': 62822,
  'face-mask': 58239,
  pickleball: 58421,
  'star-sharp-half': 57996,
  'users-slash': 57459,
  clover: 57657,
  meat: 63508,
  reply: 62437,
  'mail-reply': 62437,
  'star-and-crescent': 63129,
  'empty-set': 63062,
  'house-fire': 58636,
  'square-minus': 61766,
  'minus-square': 61766,
  helicopter: 62771,
  bird: 58473,
  compass: 61774,
  'square-caret-down': 61776,
  'caret-square-down': 61776,
  'heart-half-stroke': 57772,
  'heart-half-alt': 57772,
  'file-circle-question': 58607,
  'laptop-code': 62972,
  joystick: 63685,
  'grill-fire': 58788,
  'rectangle-vertical-history': 57911,
  swatchbook: 62915,
  'prescription-bottle': 62597,
  bars: 61641,
  navicon: 61641,
  'keyboard-left': 57795,
  'people-group': 58675,
  'hourglass-end': 62035,
  'hourglass-3': 62035,
  'heart-crack': 63401,
  'heart-broken': 63401,
  'face-beam-hand-over-mouth': 58492,
  'droplet-percent': 63312,
  humidity: 63312,
  'square-up-right': 62304,
  'external-link-square-alt': 62304,
  'face-kiss-beam': 62871,
  'kiss-beam': 62871,
  corn: 63175,
  'roller-coaster': 58148,
  'photo-film-music': 57896,
  radar: 57380,
  sickle: 63522,
  film: 61448,
  coconut: 58102,
  'ruler-horizontal': 62791,
  'shield-cross': 63250,
  'cassette-tape': 63659,
  'square-terminal': 58154,
  'people-robbery': 58678,
  lightbulb: 61675,
  'caret-left': 61657,
  'comment-middle': 57673,
  'trash-can-list': 58027,
  block: 58474,
  'circle-exclamation': 61546,
  'exclamation-circle': 61546,
  'school-circle-xmark': 58733,
  'arrow-right-from-bracket': 61579,
  'sign-out': 61579,
  'face-frown-slight': 58230,
  'circle-chevron-down': 61754,
  'chevron-circle-down': 61754,
  'sidebar-flip': 57935,
  'unlock-keyhole': 61758,
  'unlock-alt': 61758,
  'temperature-list': 58009,
  'cloud-showers-heavy': 63296,
  'headphones-simple': 62863,
  'headphones-alt': 62863,
  sitemap: 61672,
  'pipe-section': 58424,
  'space-station-moon-construction': 57396,
  'space-station-moon-alt': 57396,
  'circle-dollar-to-slot': 62649,
  donate: 62649,
  memory: 62776,
  'face-sleeping': 58253,
  'road-spikes': 58728,
  'fire-burner': 58609,
  squirrel: 63258,
  'arrow-up-to-line': 62273,
  'arrow-to-top': 62273,
  flag: 61476,
  'face-cowboy-hat': 58222,
  hanukiah: 63206,
  'chart-scatter-3d': 57576,
  'square-code': 57959,
  feather: 62765,
  'volume-low': 61479,
  'volume-down': 61479,
  'xmark-to-slot': 63345,
  'times-to-slot': 63345,
  'vote-nay': 63345,
  'box-taped': 62618,
  'box-alt': 62618,
  'comment-slash': 62643,
  swords: 63261,
  'cloud-sun-rain': 63299,
  album: 63647,
  'circle-n': 57624,
  compress: 61542,
  'wheat-awn': 58061,
  'wheat-alt': 58061,
  ankh: 63044,
  'hands-holding-child': 58618,
  asterisk: 42,
  'key-skeleton-left-right': 58292,
  'comment-lines': 62640,
  'luchador-mask': 62549,
  luchador: 62549,
  'mask-luchador': 62549,
  'square-check': 61770,
  'check-square': 61770, // duplicate of square-check and no longer documented at Font awesome.
  shredder: 63114,
  'book-open-cover': 57536,
  'book-open-alt': 57536,
  sandwich: 63519,
  'peseta-sign': 57889,
  'square-parking-slash': 62999,
  'parking-slash': 62999,
  'train-tunnel': 58452,
  heading: 61916,
  header: 61916,
  ghost: 63202,
  'face-anguished': 58217,
  'hockey-sticks': 62548,
  abacus: 63040,
  'film-simple': 62368,
  'film-alt': 62368,
  list: 61498,
  'list-squares': 61498,
  'tree-palm': 63531,
  'square-phone-flip': 63611,
  'phone-square-alt': 63611,
  'cart-plus': 61975,
  gamepad: 61723,
  'border-center-v': 63645,
  'circle-dot': 61842,
  'dot-circle': 61842,
  'clipboard-medical': 57651,
  'face-dizzy': 62823,
  dizzy: 62823,
  egg: 63483,
  'up-to-line': 62285,
  'arrow-alt-to-top': 62285,
  'house-medical-circle-xmark': 58643,
  'watch-fitness': 63038,
  'clock-nine-thirty': 58189,
  campground: 63163,
  'folder-plus': 63070,
  jug: 63686,
  futbol: 61923,
  'futbol-ball': 61923,
  'soccer-ball': 61923,
  'snow-blowing': 63329,
  paintbrush: 61948,
  'paint-brush': 61948,
  lock: 61475,
  'arrow-down-from-line': 62277,
  'arrow-from-top': 62277,
  'gas-pump': 62767,
  'signal-bars-slash': 63124,
  'signal-alt-slash': 63124,
  monkey: 63227,
  'rectangle-pro': 57909,
  pro: 57909,
  'house-night': 57360,
  'hot-tub-person': 62867,
  'hot-tub': 62867,
  blanket: 62616,
  'map-location': 62879,
  'map-marked': 62879,
  'house-flood-water': 58638,
  'comments-question-check': 57679,
  tree: 61883,
  'arrows-cross': 57506,
  backpack: 62932,
  'square-small': 57982,
  'folder-arrow-up': 57428,
  'folder-upload': 57428,
  'bridge-lock': 58572,
  'crosshairs-simple': 58783,
  'sack-dollar': 63517,
  'pen-to-square': 61508,
  edit: 61508,
  'square-sliders': 62448,
  'sliders-h-square': 62448,
  'car-side': 62948,
  'message-middle-top': 57826,
  'comment-middle-top-alt': 57826,
  'lightbulb-on': 63090,
  knife: 62180,
  'utensil-knife': 62180,
  'share-nodes': 61920,
  'share-alt': 61920,
  'wave-sine': 63641,
  'heart-circle-minus': 58623,
  'circle-w': 57644,
  'circle-calendar': 57602,
  'calendar-circle': 57602,
  'hourglass-half': 62034,
  'hourglass-2': 62034,
  microscope: 62992,
  sunset: 63335,
  sink: 57453,
  'calendar-exclamation': 62260,
  'truck-container-empty': 58037,
  'hand-heart': 62652,
  'bag-shopping': 62096,
  'shopping-bag': 62096,
  'arrow-down-z-a': 63617,
  'sort-alpha-desc': 63617,
  'sort-alpha-down-alt': 63617,
  mitten: 63413,
  'reply-clock': 57913,
  'reply-time': 57913,
  'person-rays': 58701,
  right: 62294,
  'arrow-alt-right': 62294,
  'circle-f': 57614,
  users: 61632,
  'face-pleading': 58246,
  'eye-slash': 61552,
  'flask-vial': 58611,
  'police-box': 57377,
  cucumber: 58369,
  'head-side-brain': 63496,
  hand: 62038,
  'hand-paper': 62038,
  'person-biking-mountain': 63563,
  'biking-mountain': 63563,
  'utensils-slash': 58468,
  'print-magnifying-glass': 63514,
  'print-search': 63514,
  'folder-bookmark': 57734,
  om: 63097,
  pi: 63102,
  'flask-round-potion': 63201,
  'flask-potion': 63201,
  'face-shush': 58252,
  worm: 58777,
  'house-circle-xmark': 58635,
  plug: 61926,
  'calendar-circle-exclamation': 58478,
  'square-i': 57970,
  'chevron-up': 61559,
  'face-saluting': 58500,
  'gauge-simple-low': 63020,
  'tachometer-slow': 63020,
  'face-persevering': 58245,
  'circle-camera': 57603,
  'camera-circle': 57603,
  'hand-spock': 62041,
  'spider-web': 63257,
  'circle-microphone': 57622,
  'microphone-circle': 57622,
  'book-arrow-up': 57530,
  popsicle: 58430,
  command: 57666,
  blinds: 63739,
  stopwatch: 62194,
  saxophone: 63708,
  'square-2': 57943,
  'field-hockey-stick-ball': 62540,
  'field-hockey': 62540,
  'arrow-up-square-triangle': 63627,
  'sort-shapes-up-alt': 63627,
  'face-scream': 58251,
  'square-m': 57974,
  'camera-web': 63538,
  webcam: 63538,
  'comment-arrow-down': 57667,
  'lightbulb-cfl': 58790,
  'window-frame-open': 57424,
  'face-kiss': 62870,
  kiss: 62870,
  'bridge-circle-xmark': 58571,
  period: 46,
  'face-grin-tongue': 62857,
  'grin-tongue': 62857,
  'up-to-dotted-line': 58455,
  'thought-bubble': 58158,
  raygun: 57381,
  flute: 63673,
  acorn: 63150,
  'video-arrow-up-right': 58057,
  'grate-droplet': 57748,
  'seal-exclamation': 57922,
  'chess-bishop': 62522,
  'message-sms': 57829,
  'coffee-beans': 57663,
  'hat-witch': 63207,
  'face-grin-wink': 62860,
  'grin-wink': 62860,
  'clock-three-thirty': 58199,
  'ear-deaf': 62116,
  deaf: 62116,
  deafness: 62116,
  'hard-of-hearing': 62116,
  'alarm-clock': 62286,
  eclipse: 63305,
  'face-relieved': 58249,
  'road-circle-check': 58724,
  'dice-five': 62755,
  'octagon-minus': 62216,
  'minus-octagon': 62216,
  'square-rss': 61763,
  'rss-square': 61763,
  'face-zany': 58276,
  tricycle: 58819,
  'land-mine-on': 58651,
  'square-arrow-up-left': 57955,
  'i-cursor': 62022,
  'salt-shaker': 58438,
  stamp: 62911,
  'file-plus': 62233,
  'draw-square': 62959,
  'toilet-paper-under-slash': 58017,
  'toilet-paper-reverse-slash': 58017,
  stairs: 57993,
  'drone-front': 63584,
  'drone-alt': 63584,
  'glass-empty': 57745,
  'dial-high': 57692,
  'user-helmet-safety': 63532,
  'user-construction': 63532,
  'user-hard-hat': 63532,
  i: 73,
  'hryvnia-sign': 63218,
  hryvnia: 63218,
  'arrow-down-left-and-arrow-up-right-to-center': 57490,
  pills: 62596,
  'face-grin-wide': 62849,
  'grin-alt': 62849,
  tooth: 62921,
  'basketball-hoop': 62517,
  'objects-align-bottom': 58299,
  v: 86,
  sparkles: 63632,
  squid: 58448,
  'leafy-green': 58397,
  'circle-arrow-up-right': 57596,
  calendars: 57559,
  'bangladeshi-taka-sign': 58086,
  bicycle: 61958,
  'hammer-war': 63204,
  'circle-d': 57604,
  'spider-black-widow': 63256,
  'staff-snake': 58745,
  'rod-asclepius': 58745,
  'rod-snake': 58745,
  'staff-aesculapius': 58745,
  pear: 57868,
  'head-side-cough-slash': 57442,
  triangle: 62188,
  apartment: 58472,
  'truck-medical': 61689,
  ambulance: 61689,
  pepper: 58418,
  piano: 63700,
  'gun-squirt': 57757,
  'wheat-awn-circle-exclamation': 58776,
  snowman: 63440,
  'user-alien': 57418,
  'shield-check': 62199,
  'mortar-pestle': 62887,
  'road-barrier': 58722,
  'chart-candlestick': 57570,
  'briefcase-blank': 57544,
  school: 62793,
  igloo: 63406,
  'bracket-round': 40,
  parenthesis: 40,
  joint: 62869,
  'horse-saddle': 63683,
  'mug-marshmallows': 63415,
  filters: 57726,
  'bell-on': 63738,
  'angle-right': 61701,
  'dial-med': 57695,
  horse: 63216,
  q: 81,
  'monitor-waveform': 62993,
  'monitor-heart-rate': 62993,
  'link-simple': 57805,
  whistle: 62560,
  g: 71,
  'wine-glass-crack': 62651,
  fragile: 62651,
  'slot-machine': 58318,
  'notes-medical': 62593,
  'car-wash': 62950,
  escalator: 57713,
  'comment-image': 57672,
  'temperature-half': 62153,
  'temperature-2': 62153,
  'thermometer-2': 62153,
  'thermometer-half': 62153,
  'dong-sign': 57705,
  donut: 58374,
  doughnut: 58374,
  capsules: 62571,
  'poo-storm': 63322,
  'poo-bolt': 63322,
  'tally-1': 58004,
  'face-frown-open': 62842,
  'frown-open': 62842,
  'square-dashed': 57961,
  'square-j': 57971,
  'hand-point-up': 61606,
  'money-bill': 61654,
  'arrow-up-big-small': 63630,
  'sort-size-up': 63630,
  'barcode-read': 62564,
  baguette: 58328,
  'bowl-soft-serve': 58475,
  'face-holding-back-tears': 58498,
  'square-up': 62291,
  'arrow-alt-square-up': 62291,
  'train-subway-tunnel': 58019,
  'subway-tunnel': 58019,
  'square-exclamation': 62241,
  'exclamation-square': 62241,
  semicolon: 59,
  bookmark: 61486,
  'fan-table': 57348,
  'align-justify': 61497,
  'battery-low': 57521,
  'battery-1': 57521,
  'credit-card-front': 62346,
  'brain-arrow-curved-right': 63095,
  'mind-share': 63095,
  'umbrella-beach': 62922,
  'helmet-un': 58627,
  'location-smile': 62989,
  'map-marker-smile': 62989,
  'arrow-left-to-line': 62270,
  'arrow-to-left': 62270,
  bullseye: 61760,
  sushi: 58506,
  nigiri: 58506,
  'message-captions': 57822,
  'comment-alt-captions': 57822,
  'trash-list': 58033,
  bacon: 63461,
  option: 58136,
  'hand-point-down': 61607,
  'arrow-up-from-bracket': 57498,
  'trash-plus': 58034,
  'objects-align-top': 58304,
  folder: 61563,
  'folder-blank': 61563,
  'face-anxious-sweat': 58218,
  'credit-card-blank': 62345,
  'file-waveform': 62584,
  'file-medical-alt': 62584,
  'microchip-ai': 57836,
  mug: 63604,
  'plane-up-slash': 57902,
  radiation: 63417,
  'pen-circle': 57870,
  'chart-simple': 58483,
  crutches: 63480,
  'circle-parking': 62997,
  'parking-circle': 62997,
  'mars-stroke': 61993,
  'leaf-oak': 63223,
  'square-bolt': 57957,
  vial: 62610,
  gauge: 63012,
  dashboard: 63012,
  'gauge-med': 63012,
  'tachometer-alt-average': 63012,
  'wand-magic-sparkles': 58058,
  'magic-wand-sparkles': 58058,
  lambda: 63086,
  e: 69,
  pizza: 63511,
  'bowl-chopsticks-noodles': 58090,
  h3: 62229,
  'pen-clip': 62213,
  'pen-alt': 62213,
  'bridge-circle-exclamation': 58570,
  'badge-percent': 63046,
  user: 61447,
  sensor: 57384,
  comma: 44,
  'school-circle-check': 58731,
  'toilet-paper-under': 58016,
  'toilet-paper-reverse': 58016,
  'light-emergency': 58399,
  'arrow-down-to-arc': 58542,
  dumpster: 63379,
  'van-shuttle': 62902,
  'shuttle-van': 62902,
  'building-user': 58586,
  'light-switch': 57367,
  'square-caret-left': 61841,
  'caret-square-left': 61841,
  highlighter: 62865,
  'wave-pulse': 62968,
  'heart-rate': 62968,
  key: 61572,
  'hat-santa': 63399,
  tamale: 58449,
  'box-check': 62567,
  bullhorn: 61601,
  steak: 63524,
  'location-crosshairs-slash': 62979,
  'location-slash': 62979,
  'person-dolly': 62672,
  globe: 61612,
  synagogue: 63131,
  'file-chart-column': 63065,
  'file-chart-line': 63065,
  'person-half-dress': 58696,
  'folder-image': 57738,
  'calendar-pen': 62259,
  'calendar-edit': 62259,
  'road-bridge': 58723,
  'face-smile-tear': 58259,
  'message-plus': 62632,
  'comment-alt-plus': 62632,
  'location-arrow': 61732,
  c: 67,
  'tablet-button': 61706,
  'rectangle-history-circle-user': 58532,
  'building-lock': 58582,
  'chart-line-up': 57573,
  mailbox: 63507,
  'truck-bolt': 58320,
  'pizza-slice': 63512,
  'money-bill-wave': 62778,
  'chart-area': 61950,
  'area-chart': 61950,
  'house-flag': 58637,
  'person-circle-minus': 58688,
  scalpel: 63005,
  ban: 61534,
  cancel: 61534,
  'bell-exclamation': 63560,
  'circle-bookmark': 57600,
  'bookmark-circle': 57600,
  'egg-fried': 63484,
  'face-weary': 58273,
  'uniform-martial-arts': 58321,
  'camera-rotate': 57560,
  'sun-dust': 63332,
  'comment-text': 57677,
  'spray-can-sparkles': 62928,
  'air-freshener': 62928,
  'signal-bars': 63120,
  'signal-alt': 63120,
  'signal-alt-4': 63120,
  'signal-bars-strong': 63120,
  'diamond-exclamation': 58373,
  star: 61445,
  'dial-min': 57697,
  repeat: 62307,
  cross: 63060,
  'page-caret-down': 58409,
  'file-caret-down': 58409,
  box: 62566,
  'venus-mars': 61992,
  'clock-seven-thirty': 58193,
  'arrow-pointer': 62021,
  'mouse-pointer': 62021,
  'clock-four-thirty': 58187,
  'signal-bars-good': 63123,
  'signal-alt-3': 63123,
  cactus: 63655,
  maximize: 62238,
  'expand-arrows-alt': 62238,
  'charging-station': 62951,
  shapes: 63007,
  'triangle-circle-square': 63007,
  'plane-tail': 57900,
  'gauge-simple-max': 63019,
  'tachometer-fastest': 63019,
  'circle-u': 57639,
  'shield-slash': 57931,
  'square-phone-hangup': 57978,
  'phone-square-down': 57978,
  'arrow-up-left': 57501,
  'transporter-1': 57411,
  peanuts: 58417,
  shuffle: 61556,
  random: 61556,
  'person-running': 63244,
  running: 63244,
  'mobile-retro': 58663,
  'grip-lines-vertical': 63397,
  'arrow-up-from-square': 57500,
  'file-dashed-line': 63607,
  'page-break': 63607,
  'bracket-curly-right': 125,
  spider: 63255,
  'clock-three': 58198,
  'hands-bound': 58617,
  'scalpel-line-dashed': 63006,
  'scalpel-path': 63006,
  'file-invoice-dollar': 62833,
  'pipe-smoking': 58308,
  'face-astonished': 58219,
  window: 62478,
  'plane-circle-exclamation': 58710,
  ear: 62960,
  'file-lock': 58278,
  'diagram-venn': 57690,
  'x-ray': 62615,
  'goal-net': 58283,
  'coffin-cross': 57425,
  'spell-check': 63633,
  'location-xmark': 62990,
  'map-marker-times': 62990,
  'map-marker-xmark': 62990,
  lasso: 63688,
  slash: 63253,
  'person-to-portal': 57378,
  'portal-enter': 57378,
  'calendar-star': 63286,
  'computer-mouse': 63692,
  mouse: 63692,
  'arrow-right-to-bracket': 61584,
  'sign-in': 61584,
  pegasus: 63235,
  'files-medical': 63485,
  'nfc-lock': 57848,
  'person-ski-lift': 63432,
  'ski-lift': 63432,
  'square-6': 57947,
  'shop-slash': 57456,
  'store-alt-slash': 57456,
  'wind-turbine': 63643,
  'sliders-simple': 57939,
  'badge-sheriff': 63650,
  server: 62003,
  'virus-covid-slash': 58537,
  intersection: 63080,
  'shop-lock': 58533,
  family: 58112,
  'hourglass-start': 62033,
  'hourglass-1': 62033,
  'user-hair-buns': 58323,
  'blender-phone': 63158,
  'hourglass-clock': 58395,
  'person-seat-reclined': 57887,
  'paper-plane-top': 57866,
  'paper-plane-alt': 57866,
  send: 57866,
  'message-arrow-up': 57820,
  'comment-alt-arrow-up': 57820,
  'lightbulb-exclamation': 63089,
  'layer-minus': 62974,
  'layer-group-minus': 62974,
  'circle-e': 57609,
  'building-wheat': 58587,
  'gauge-max': 63014,
  'tachometer-alt-fastest': 63014,
  'person-breastfeeding': 58682,
  apostrophe: 39,
  'fire-hydrant': 57727,
  'right-to-bracket': 62198,
  'sign-in-alt': 62198,
  'video-plus': 62689,
  'square-right': 62290,
  'arrow-alt-square-right': 62290,
  'comment-smile': 62644,
  venus: 61985,
  passport: 62891,
  'inbox-in': 62224,
  'inbox-arrow-down': 62224,
  'heart-pulse': 61982,
  heartbeat: 61982,
  'circle-8': 57589,
  'clouds-moon': 63301,
  'clock-ten-thirty': 58197,
  'people-carry-box': 62670,
  'people-carry': 62670,
  'folder-user': 57742,
  'trash-can-xmark': 58030,
  'temperature-high': 63337,
  microchip: 62171,
  'left-long-to-line': 58398,
  crown: 62753,
  'weight-hanging': 62925,
  'xmarks-lines': 58778,
  'file-prescription': 62834,
  'calendar-range': 57558,
  'flower-daffodil': 63488,
  'hand-back-point-up': 57762,
  'weight-scale': 62614,
  weight: 62614,
  'star-exclamation': 62195,
  books: 62939,
  'user-group': 62720,
  'user-friends': 62720,
  'arrow-up-a-z': 61790,
  'sort-alpha-up': 61790,
  'layer-plus': 62975,
  'layer-group-plus': 62975,
  'play-pause': 57903,
  'block-question': 58333,
  snooze: 63616,
  zzz: 63616,
  'scanner-image': 63731,
  'tv-retro': 62465,
  'square-t': 57984,
  farm: 63588,
  'barn-silo': 63588,
  'chess-knight': 62529,
  'bars-sort': 57518,
  'pallet-boxes': 62595,
  'palette-boxes': 62595,
  'pallet-alt': 62595,
  'face-laugh-squint': 62875,
  'laugh-squint': 62875,
  'code-simple': 57661,
  'bolt-slash': 57528,
  'panel-fire': 58415,
  'binary-circle-check': 58172,
  'comment-minus': 62641,
  burrito: 63469,
  violin: 63725,
  'objects-column': 58305,
  'square-chevron-down': 62249,
  'chevron-square-down': 62249,
  'comment-plus': 62642,
  'triangle-instrument': 63714,
  'triangle-music': 63714,
  wheelchair: 61843,
  'user-pilot-tie': 58049,
  'piano-keyboard': 63701,
  'bed-empty': 63737,
  'circle-arrow-up': 61610,
  'arrow-circle-up': 61610,
  'toggle-on': 61957,
  'rectangle-vertical': 62203,
  'rectangle-portrait': 62203,
  'person-walking': 62804,
  walking: 62804,
  l: 76,
  'signal-stream': 63709,
  'down-to-bracket': 58599,
  'circle-z': 57648,
  stars: 63330,
  fire: 61549,
  'bed-pulse': 62599,
  procedures: 62599,
  'house-day': 57358,
  'shuttle-space': 61847,
  'space-shuttle': 61847,
  'shirt-long-sleeve': 58311,
  'chart-pie-simple': 63054,
  'chart-pie-alt': 63054,
  'face-laugh': 62873,
  laugh: 62873,
  'folder-open': 61564,
  'album-collection-circle-user': 58511,
  candy: 58343,
  'bowl-hot': 63523,
  soup: 63523,
  flatbread: 58379,
  'heart-circle-plus': 58624,
  'code-fork': 57659,
  city: 63055,
  'signal-bars-weak': 63121,
  'signal-alt-1': 63121,
  'microphone-lines': 62409,
  'microphone-alt': 62409,
  'clock-twelve': 58200,
  'pepper-hot': 63510,
  'citrus-slice': 58101,
  sheep: 63249,
  unlock: 61596,
  'colon-sign': 57664,
  headset: 62864,
  'badger-honey': 63156,
  h4: 63594,
  'store-slash': 57457,
  'road-circle-xmark': 58726,
  'signal-slash': 63125,
  'user-minus': 62723,
  'mars-stroke-up': 61994,
  'mars-stroke-v': 61994,
  'champagne-glasses': 63391,
  'glass-cheers': 63391,
  taco: 63526,
  'hexagon-plus': 62208,
  'plus-hexagon': 62208,
  clipboard: 62248,
  'house-circle-exclamation': 58634,
  'file-arrow-up': 62836,
  'file-upload': 62836,
  wifi: 61931,
  'wifi-3': 61931,
  'wifi-strong': 61931,
  messages: 62646,
  'comments-alt': 62646,
  bath: 62157,
  bathtub: 62157,
  'umbrella-simple': 58044,
  'umbrella-alt': 58044,
  'rectangle-history-circle-plus': 58531,
  underline: 61645,
  'prescription-bottle-pill': 58816,
  'user-pen': 62719,
  'user-edit': 62719,
  'binary-slash': 58174,
  'square-o': 57976,
  signature: 62903,
  stroopwafel: 62801,
  bold: 61490,
  'anchor-lock': 58541,
  'building-ngo': 58583,
  'transporter-3': 57413,
  'engine-warning': 62962,
  'engine-exclamation': 62962,
  'circle-down-right': 57608,
  'square-k': 57972,
  'manat-sign': 57813,
  'money-check-pen': 63602,
  'money-check-edit': 63602,
  'not-equal': 62782,
  'border-top-left': 63571,
  'border-style': 63571,
  'map-location-dot': 62880,
  'map-marked-alt': 62880,
  tilde: 126,
  jedi: 63081,
  'square-poll-vertical': 63105,
  poll: 63105,
  'arrow-down-square-triangle': 63625,
  'sort-shapes-down-alt': 63625,
  'mug-hot': 63414,
  'dog-leashed': 63188,
  'car-battery': 62943,
  'battery-car': 62943,
  'face-downcast-sweat': 58225,
  'mailbox-flag-up': 58811,
  'memo-circle-info': 58522,
  gift: 61547,
  'dice-two': 62760,
  volume: 63144,
  'volume-medium': 63144,
  'transporter-5': 58022,
  'gauge-circle-bolt': 58518,
  'coin-front': 58364,
  'file-slash': 58279,
  'message-arrow-up-right': 57821,
  'treasure-chest': 63267,
  'chess-queen': 62533,
  'paintbrush-fine': 62889,
  'paint-brush-alt': 62889,
  'paint-brush-fine': 62889,
  'paintbrush-alt': 62889,
  glasses: 62768,
  'hood-cloak': 63215,
  'square-quote': 58153,
  'up-left': 58045,
  'bring-front': 63575,
  'chess-board': 62524,
  'burger-cheese': 63473,
  cheeseburger: 63473,
  'building-circle-check': 58578,
  'repeat-1': 62309,
  'arrow-down-to-line': 62269,
  'arrow-to-bottom': 62269,
  'grid-5': 57753,
  'right-long-to-line': 58436,
  'person-chalkboard': 58685,
  'mars-stroke-right': 61995,
  'mars-stroke-h': 61995,
  'hand-back-fist': 62037,
  'hand-rock': 62037,
  tally: 63132,
  'tally-5': 63132,
  'square-caret-up': 61777,
  'caret-square-up': 61777,
  'cloud-showers-water': 58596,
  'chart-bar': 61568,
  'bar-chart': 61568,
  'hands-bubbles': 57438,
  'hands-wash': 57438,
  'less-than-equal': 62775,
  train: 62008,
  'up-from-dotted-line': 58454,
  'eye-low-vision': 62120,
  'low-vision': 62120,
  'traffic-light-go': 63032,
  'face-exhaling': 58496,
  'sensor-fire': 57386,
  'user-unlock': 57432,
  'hexagon-divide': 57773,
  '00': 58471,
  crow: 62752,
  'cassette-betamax': 63652,
  betamax: 63652,
  sailboat: 58437,
  'window-restore': 62162,
  'nfc-magnifying-glass': 57849,
  'file-binary': 57717,
  'circle-v': 57642,
  'square-plus': 61694,
  'plus-square': 61694,
  'bowl-scoops': 58335,
  mistletoe: 63412,
  custard: 58371,
  'lacrosse-stick': 58293,
  'hockey-mask': 63214,
  sunrise: 63334,
  'panel-ews': 58414,
  'torii-gate': 63137,
  'cloud-exclamation': 58513,
  'message-lines': 62630,
  'comment-alt-lines': 62630,
  frog: 62766,
  bucket: 58575,
  'floppy-disk-pen': 57730,
  image: 61502,
  'window-frame': 57423,
  microphone: 61744,
  cow: 63176,
  'square-ring': 58447,
  'down-from-line': 62281,
  'arrow-alt-from-top': 62281,
  'caret-up': 61656,
  'shield-xmark': 57932,
  'shield-times': 57932,
  screwdriver: 62794,
  'circle-sort-down': 57393,
  'sort-circle-down': 57393,
  'folder-closed': 57733,
  'house-tsunami': 58645,
  'square-nfi': 58742,
  forklift: 62586,
  'arrow-up-from-ground-water': 58549,
  'bracket-square-right': 93,
  'martini-glass': 62843,
  'glass-martini-alt': 62843,
  'rotate-left': 62186,
  'rotate-back': 62186,
  'rotate-backward': 62186,
  'undo-alt': 62186,
  'table-columns': 61659,
  columns: 61659,
  'square-a': 57951,
  tick: 58159,
  lemon: 61588,
  'head-side-mask': 57443,
  handshake: 62133,
  gem: 62373,
  dolly: 62578,
  'dolly-box': 62578,
  smoking: 62605,
  minimize: 63372,
  'compress-arrows-alt': 63372,
  refrigerator: 57382,
  monument: 62886,
  'octagon-xmark': 62192,
  'times-octagon': 62192,
  'xmark-octagon': 62192,
  'align-slash': 63558,
  snowplow: 63442,
  'angles-right': 61697,
  'angle-double-right': 61697,
  'truck-ramp-couch': 62685,
  'truck-couch': 62685,
  cannabis: 62815,
  'circle-play': 61764,
  'play-circle': 61764,
  'arrow-up-right-and-arrow-down-left-from-center': 57504,
  tablets: 62608,
  '360-degrees': 58076,
  ethernet: 63382,
  'euro-sign': 61779,
  eur: 61779,
  euro: 61779,
  chair: 63168,
  'circle-check': 61528,
  'check-circle': 61528,
  'square-dashed-circle-plus': 58818,
  'money-simple-from-bracket': 58131,
  bat: 63157,
  'circle-stop': 62093,
  'stop-circle': 62093,
  'head-side-headphones': 63682,
  'phone-rotary': 63699,
  'compass-drafting': 62824,
  'drafting-compass': 62824,
  'plate-wheat': 58714,
  'calendar-circle-minus': 58479,
  chopsticks: 58359,
  'car-wrench': 62947,
  'car-mechanic': 62947,
  icicles: 63405,
  'person-shelter': 58703,
  neuter: 61996,
  'id-badge': 62145,
  kazoo: 63687,
  marker: 62881,
  'face-laugh-beam': 62874,
  'laugh-beam': 62874,
  'square-arrow-down-left': 57953,
  'battery-bolt': 62326,
  'tree-large': 63453,
  'helicopter-symbol': 58626,
  aperture: 58079,
  'universal-access': 62106,
  'file-magnifying-glass': 63589,
  'file-search': 63589,
  'up-right': 58046,
  'circle-chevron-up': 61753,
  'chevron-circle-up': 61753,
  'user-police': 58163,
  'lari-sign': 57800,
  volcano: 63344,
  'teddy-bear': 58319,
  stocking: 63445,
  'person-walking-dashed-line-arrow-right': 58707,
  'image-slash': 57783,
  'mask-snorkel': 58295,
  smoke: 63328,
  'sterling-sign': 61780,
  gbp: 61780,
  'pound-sign': 61780,
  'battery-exclamation': 57520,
  viruses: 57462,
  'square-person-confined': 58743,
  'user-tie': 62728,
  'arrow-down-long': 61813,
  'long-arrow-down': 61813,
  'tent-arrow-down-to-line': 58750,
  certificate: 61603,
  'crystal-ball': 58210,
  'reply-all': 61730,
  'mail-reply-all': 61730,
  suitcase: 61682,
  'person-skating': 63429,
  skating: 63429,
  'star-shooting': 57398,
  'binary-lock': 58173,
  'filter-circle-dollar': 63074,
  'funnel-dollar': 63074,
  'camera-retro': 61571,
  'circle-arrow-down': 61611,
  'arrow-circle-down': 61611,
  'comment-pen': 62638,
  'comment-edit': 62638,
  'file-import': 62831,
  'arrow-right-to-file': 62831,
  banjo: 63651,
  'square-arrow-up-right': 61772,
  'external-link-square': 61772,
  'light-emergency-on': 58400,
  kerning: 63599,
  'box-open': 62622,
  'square-f': 57968,
  scroll: 63246,
  spa: 62907,
  'arrow-left-from-line': 62276,
  'arrow-from-right': 62276,
  strawberry: 58155,
  'location-pin-lock': 58655,
  pause: 61516,
  'clock-eight-thirty': 58182,
  'plane-engines': 62430,
  'plane-alt': 62430,
  'hill-avalanche': 58631,
  'temperature-empty': 62155,
  'temperature-0': 62155,
  'thermometer-0': 62155,
  'thermometer-empty': 62155,
  bomb: 61922,
  'gauge-low': 63015,
  'tachometer-alt-slow': 63015,
  registered: 62045,
  'trash-can-plus': 58028,
  'address-card': 62139,
  'contact-card': 62139,
  vcard: 62139,
  'scale-unbalanced-flip': 62742,
  'balance-scale-right': 62742,
  'globe-snow': 63395,
  subscript: 61740,
  'diamond-turn-right': 62955,
  directions: 62955,
  integral: 63079,
  burst: 58588,
  'house-laptop': 57446,
  'laptop-house': 57446,
  'face-tired': 62920,
  tired: 62920,
  'money-bills': 57843,
  'blinds-raised': 63741,
  smog: 63327,
  'ufo-beam': 57416,
  'circle-caret-up': 62257,
  'caret-circle-up': 62257,
  'user-vneck-hair-long': 58467,
  'square-a-lock': 58445,
  crutch: 63479,
  'gas-pump-slash': 62964,
  'cloud-arrow-up': 61678,
  'cloud-upload': 61678,
  'cloud-upload-alt': 61678,
  palette: 62783,
  'transporter-4': 58021,
  'objects-align-right': 58303,
  'arrows-turn-right': 58560,
  vest: 57477,
  pig: 63238,
  'inbox-full': 57786,
  'circle-envelope': 57612,
  'envelope-circle': 57612,
  'triangle-person-digging': 63581,
  construction: 63581,
  ferry: 58602,
  'bullseye-arrow': 63048,
  'arrows-down-to-people': 58553,
  seedling: 62680,
  sprout: 62680,
  'clock-seven': 58192,
  'left-right': 62263,
  'arrows-alt-h': 62263,
  'boxes-packing': 58567,
  'circle-arrow-left': 61608,
  'arrow-circle-left': 61608,
  flashlight: 63672,
  'group-arrows-rotate': 58614,
  'bowl-food': 58566,
  'square-9': 57950,
  'candy-cane': 63366,
  'arrow-down-wide-short': 61792,
  'sort-amount-asc': 61792,
  'sort-amount-down': 61792,
  'square-dollar': 62185,
  'dollar-square': 62185,
  'usd-square': 62185,
  'phone-arrow-right': 58814,
  'hand-holding-seedling': 62655,
  'message-check': 62626,
  'comment-alt-check': 62626,
  'cloud-bolt': 63340,
  thunderstorm: 63340,
  'text-slash': 63613,
  'remove-format': 63613,
  watch: 62177,
  'circle-down-left': 57607,
  text: 63635,
  projector: 63702,
  'face-smile-wink': 62682,
  'smile-wink': 62682,
  'tombstone-blank': 63265,
  'tombstone-alt': 63265,
  'chess-king-piece': 62528,
  'chess-king-alt': 62528,
  'circle-6': 57587,
  left: 62293,
  'arrow-alt-left': 62293,
  'file-word': 61890,
  'file-powerpoint': 61892,
  'square-down': 62288,
  'arrow-alt-square-down': 62288,
  'objects-align-center-vertical': 58301,
  'arrows-left-right': 61566,
  'arrows-h': 61566,
  'house-lock': 58640,
  'cloud-arrow-down': 61677,
  'cloud-download': 61677,
  'cloud-download-alt': 61677,
  wreath: 63458,
  children: 58593,
  'meter-droplet': 57834,
  chalkboard: 62747,
  blackboard: 62747,
  'user-large-slash': 62714,
  'user-alt-slash': 62714,
  'signal-strong': 63119,
  'signal-4': 63119,
  lollipop: 58404,
  lollypop: 58404,
  'list-tree': 57810,
  'envelope-open': 62134,
  'draw-circle': 62957,
  'cat-space': 57345,
  'handshake-simple-slash': 57439,
  'handshake-alt-slash': 57439,
  'rabbit-running': 63241,
  'rabbit-fast': 63241,
  'memo-pad': 57818,
  'mattress-pillow': 58661,
  'alarm-plus': 63556,
  alicorn: 63152,
  'comment-question': 57675,
  'gingerbread-man': 63389,
  'guarani-sign': 57754,
  'burger-fries': 57549,
  'mug-tea': 63605,
  'border-top': 63573,
  'arrows-rotate': 61473,
  refresh: 61473,
  sync: 61473,
  'circle-book-open': 57599,
  'book-circle': 57599,
  'arrows-to-dotted-line': 57510,
  'fire-extinguisher': 61748,
  'garage-open': 57355,
  'shelves-empty': 57926,
  'cruzeiro-sign': 57682,
  'watch-apple': 58059,
  'watch-calculator': 63728,
  'list-dropdown': 57807,
  'cabinet-filing': 63051,
  'burger-soda': 63576,
  'square-arrow-up': 62268,
  'arrow-square-up': 62268,
  'greater-than-equal': 62770,
  'pallet-box': 57864,
  'face-confounded': 58220,
  'shield-halved': 62445,
  'shield-alt': 62445,
  'truck-plow': 63454,
  'book-atlas': 62808,
  atlas: 62808,
  virus: 57460,
  'comment-middle-top': 57674,
  'envelope-circle-check': 58600,
  'layer-group': 62973,
  'restroom-simple': 57914,
  'arrows-to-dot': 58558,
  'border-outer': 63569,
  'hashtag-lock': 58389,
  'clock-two-thirty': 58203,
  archway: 62807,
  'heart-circle-check': 58621,
  'house-chimney-crack': 63217,
  'house-damage': 63217,
  'file-zipper': 61894,
  'file-archive': 61894,
  'heart-half': 57771,
  'comment-check': 62636,
  square: 61640,
  memo: 57816,
  'martini-glass-empty': 61440,
  'glass-martini': 61440,
  couch: 62648,
  'cedi-sign': 57567,
  italic: 61491,
  'glass-citrus': 63593,
  'calendar-lines-pen': 58482,
  church: 62749,
  'person-snowmobiling': 63441,
  snowmobile: 63441,
  'face-hushed': 58235,
  'comments-dollar': 63059,
  pickaxe: 58815,
  'link-simple-slash': 57806,
  democrat: 63303,
  'face-confused': 58221,
  pinball: 57897,
  z: 90,
  'person-skiing': 63433,
  skiing: 63433,
  deer: 63374,
  'input-pipe': 57790,
  'road-lock': 58727,
  a: 65,
  'bookmark-slash': 57538,
  'temperature-arrow-down': 57407,
  'temperature-down': 57407,
  mace: 63224,
  'feather-pointed': 62827,
  'feather-alt': 62827,
  sausage: 63520,
  'trash-can-clock': 58026,
  p: 80,
  snowflake: 62172,
  stomach: 63011,
  newspaper: 61930,
  'rectangle-ad': 63041,
  ad: 63041,
  'guitar-electric': 63678,
  'arrow-turn-down-right': 58326,
  'moon-cloud': 63316,
  'bread-slice-butter': 58337,
  'circle-arrow-right': 61609,
  'arrow-circle-right': 61609,
  'user-group-crown': 63141,
  'users-crown': 63141,
  'circle-i': 57617,
  'toilet-paper-check': 58802,
  'filter-circle-xmark': 57723,
  locust: 58656,
  sort: 61660,
  unsorted: 61660,
  'list-ol': 61643,
  'list-1-2': 61643,
  'list-numeric': 61643,
  'chart-waterfall': 57579,
  'face-party': 58243,
  kidneys: 62971,
  'wifi-exclamation': 58063,
  'chart-network': 63370,
  'person-dress-burst': 58692,
  'dice-d4': 63184,
  'money-check-dollar': 62781,
  'money-check-alt': 62781,
  'vector-square': 62923,
  'bread-slice': 63468,
  language: 61867,
  'wheat-awn-slash': 58168,
  'face-kiss-wink-heart': 62872,
  'kiss-wink-heart': 62872,
  dagger: 63179,
  podium: 63104,
  'memo-circle-check': 57817,
  'route-highway': 63002,
  'down-to-line': 62282,
  'arrow-alt-to-bottom': 62282,
  filter: 61616,
  'square-g': 57969,
  'circle-phone': 57627,
  'phone-circle': 57627,
  'clipboard-prescription': 62952,
  'user-nurse-hair': 58461,
  question: 63,
  'file-signature': 62835,
  'toggle-large-on': 58801,
  'up-down-left-right': 61618,
  'arrows-alt': 61618,
  'dryer-heat': 63586,
  'dryer-alt': 63586,
  'house-chimney-user': 57445,
  'hand-holding-heart': 62654,
  'arrow-up-small-big': 63631,
  'sort-size-up-alt': 63631,
  'train-track': 58451,
  'puzzle-piece': 61742,
  'money-check': 62780,
  'star-half-stroke': 62912,
  'star-half-alt': 62912,
  'file-exclamation': 62234,
  code: 61729,
  'whiskey-glass': 63392,
  'glass-whiskey': 63392,
  'moon-stars': 63317,
  'building-circle-exclamation': 58579,
  'clothes-hanger': 57654,
  'mobile-notch': 57838,
  'mobile-iphone': 57838,
  'magnifying-glass-chart': 58658,
  'arrow-up-right-from-square': 61582,
  'external-link': 61582,
  'cubes-stacked': 58598,
  'images-user': 57785,
  'won-sign': 61785,
  krw: 61785,
  won: 61785,
  'image-polaroid-user': 57782,
  'virus-covid': 58536,
  'square-ellipsis': 57966,
  pie: 63237,
  'chess-knight-piece': 62530,
  'chess-knight-alt': 62530,
  'austral-sign': 57513,
  'cloud-plus': 58206,
  f: 70,
  leaf: 61548,
  'bed-bunk': 63736,
  road: 61464,
  taxi: 61882,
  cab: 61882,
  'person-circle-plus': 58689,
  'chart-pie': 61952,
  'pie-chart': 61952,
  'bolt-lightning': 57527,
  'clock-eight': 58181,
  'sack-xmark': 58730,
  'file-excel': 61891,
  'file-contract': 62828,
  'fish-fins': 58610,
  'circle-q': 57630,
  'building-flag': 58581,
  'face-grin-beam': 62850,
  'grin-beam': 62850,
  'object-ungroup': 62024,
  'face-disguise': 58224,
  'circle-arrow-down-right': 57594,
  'alien-8bit': 63734,
  'alien-monster': 63734,
  'hand-point-ribbon': 57766,
  poop: 63001,
  'object-exclude': 58524,
  telescope: 57406,
  'location-pin': 61505,
  'map-marker': 61505,
  'square-list': 58505,
  kaaba: 63083,
  'toilet-paper': 63262,
  'helmet-safety': 63495,
  'hard-hat': 63495,
  'hat-hard': 63495,
  'comment-code': 57671,
  'sim-cards': 57937,
  starship: 57401,
  eject: 61522,
  'circle-right': 62298,
  'arrow-alt-circle-right': 62298,
  'plane-circle-check': 58709,
  seal: 57921,
  'user-cowboy': 63722,
  'hexagon-vertical-nft': 58629,
  'face-rolling-eyes': 62885,
  'meh-rolling-eyes': 62885,
  'bread-loaf': 63467,
  'rings-wedding': 63515,
  'object-group': 62023,
  'french-fries': 63491,
  'chart-line': 61953,
  'line-chart': 61953,
  'calendar-arrow-down': 57552,
  'calendar-download': 57552,
  'send-back': 63614,
  'mask-ventilator': 58660,
  'signature-lock': 58314,
  'arrow-right': 61537,
  'signs-post': 62071,
  'map-signs': 62071,
  'octagon-plus': 62209,
  'plus-octagon': 62209,
  'cash-register': 63368,
  'person-circle-question': 58690,
  'melon-slice': 58129,
  'space-station-moon': 57395,
  'message-smile': 62634,
  'comment-alt-smile': 62634,
  'cup-straw': 58211,
  'left-from-line': 62280,
  'arrow-alt-from-right': 62280,
  h: 72,
  'basket-shopping-simple': 57519,
  'shopping-basket-alt': 57519,
  'hands-holding-heart': 62659,
  'hands-heart': 62659,
  'clock-nine': 58188,
  tarp: 58747,
  'face-sleepy': 58254,
  'hand-horns': 57769,
  'screwdriver-wrench': 63449,
  tools: 63449,
  'arrows-to-eye': 58559,
  'circle-three-quarters': 57637,
  'trophy-star': 62187,
  'trophy-alt': 62187,
  'plug-circle-bolt': 58715,
  'face-thermometer': 58266,
  'shirt-running': 58312,
  'book-circle-arrow-up': 57533,
  'face-nauseated': 58241,
  heart: 61444,
  'file-chart-pie': 63066,
  'mars-and-venus': 61988,
  'house-user': 57776,
  'home-user': 57776,
  'circle-arrow-down-left': 57593,
  'dumpster-fire': 63380,
  'hexagon-minus': 62215,
  'minus-hexagon': 62215,
  'left-to-line': 62283,
  'arrow-alt-to-left': 62283,
  'house-crack': 58289,
  'paw-simple': 63233,
  'paw-alt': 63233,
  'arrow-left-long-to-line': 58324,
  'brackets-round': 57541,
  parentheses: 57541,
  'martini-glass-citrus': 62817,
  cocktail: 62817,
  'user-shakespeare': 58050,
  'arrow-right-to-arc': 58546,
  'face-surprise': 62914,
  surprise: 62914,
  'bottle-water': 58565,
  'circle-pause': 62091,
  'pause-circle': 62091,
  'gauge-circle-plus': 58520,
  folders: 63072,
  angel: 63353,
  'value-absolute': 63142,
  rabbit: 63240,
  'toilet-paper-slash': 57458,
  'apple-whole': 62929,
  'apple-alt': 62929,
  'kitchen-set': 58650,
  'diamond-half': 58807,
  'lock-keyhole': 62221,
  'lock-alt': 62221,
  r: 82,
  'temperature-quarter': 62154,
  'temperature-1': 62154,
  'thermometer-1': 62154,
  'thermometer-quarter': 62154,
  'square-info': 62223,
  'info-square': 62223,
  'wifi-slash': 63148,
  'toilet-paper-xmark': 58803,
  'hands-holding-dollar': 62661,
  'hands-usd': 62661,
  cube: 61874,
  'arrow-down-triangle-square': 63624,
  'sort-shapes-down': 63624,
  'bitcoin-sign': 57524,
  shutters: 58441,
  'shield-dog': 58739,
  'solar-panel': 62906,
  'lock-open': 62401,
  'table-tree': 58003,
  'house-chimney-heart': 57778,
  'tally-3': 58006,
  elevator: 57709,
  'money-bill-transfer': 58664,
  'money-bill-trend-up': 58665,
  'house-flood-water-circle-arrow-right': 58639,
  'square-poll-horizontal': 63106,
  'poll-h': 63106,
  circle: 61713,
  'cart-circle-exclamation': 58354,
  sword: 63260,
  'backward-fast': 61513,
  'fast-backward': 61513,
  recycle: 61880,
  'user-astronaut': 62715,
  interrobang: 58810,
  'plane-slash': 57449,
  'circle-dashed': 57605,
  trademark: 62044,
  basketball: 62516,
  'basketball-ball': 62516,
  'fork-knife': 62182,
  'utensils-alt': 62182,
  'satellite-dish': 63424,
  'badge-check': 62262,
  'circle-up': 62299,
  'arrow-alt-circle-up': 62299,
  slider: 57938,
  'mobile-screen-button': 62413,
  'mobile-alt': 62413,
  'clock-one-thirty': 58191,
  'inbox-out': 62225,
  'inbox-arrow-up': 62225,
  'cloud-slash': 57655,
  'volume-high': 61480,
  'volume-up': 61480,
  'users-rays': 58771,
  wallet: 62805,
  'octagon-check': 58406,
  'flatbread-stuffed': 58380,
  'clipboard-check': 62572,
  'cart-circle-plus': 58355,
  'truck-clock': 62604,
  'shipping-timed': 62604,
  'pool-8-ball': 58309,
  'file-audio': 61895,
  'turn-down-left': 58161,
  'lock-hashtag': 58403,
  'chart-radar': 57575,
  staff: 63259,
  burger: 63493,
  hamburger: 63493,
  'utility-pole': 58051,
  'transporter-6': 58023,
  wrench: 61613,
  bugs: 58576,
  'vector-polygon': 58055,
  'diagram-nested': 57687,
  'rupee-sign': 61782,
  rupee: 61782,
  'file-image': 61893,
  'circle-question': 61529,
  'question-circle': 61529,
  'image-user': 57784,
  buoy: 58805,
  'plane-departure': 62896,
  'handshake-slash': 57440,
  'book-bookmark': 57531,
  'border-center-h': 63644,
  'can-food': 58342,
  typewriter: 63719,
  'arrow-right-from-arc': 58545,
  'circle-k': 57619,
  'face-hand-over-mouth': 58232,
  popcorn: 63513,
  'house-water': 63311,
  'house-flood': 63311,
  'object-subtract': 58526,
  'code-branch': 61734,
  'warehouse-full': 62613,
  'warehouse-alt': 62613,
  'hat-cowboy': 63680,
  bridge: 58568,
  'phone-flip': 63609,
  'phone-alt': 63609,
  'arrow-down-from-dotted-line': 57488,
  'square-quarters': 58446,
  'truck-front': 58039,
  cat: 63166,
  'trash-xmark': 58036,
  'circle-caret-left': 62254,
  'caret-circle-left': 62254,
  files: 57720,
  'anchor-circle-exclamation': 58539,
  'face-clouds': 58493,
  'user-crown': 63140,
  'truck-field': 58765,
  route: 62679,
  'cart-circle-check': 58353,
  'clipboard-question': 58595,
  panorama: 57865,
  'comment-medical': 63477,
  'teeth-open': 63023,
  'user-tie-hair-long': 58464,
  'file-circle-minus': 58605,
  'head-side-medical': 63497,
  tags: 61484,
  'wine-glass': 62691,
  'forward-fast': 61520,
  'fast-forward': 61520,
  'face-meh-blank': 62884,
  'meh-blank': 62884,
  'user-robot': 57419,
  'square-parking': 62784,
  parking: 62784,
  'card-diamond': 58346,
  'face-zipper': 58277,
  'face-raised-eyebrow': 58248,
  'house-signal': 57362,
  'square-chevron-up': 62252,
  'chevron-square-up': 62252,
  'bars-progress': 63528,
  'tasks-alt': 63528,
  'faucet-drip': 57350,
  'arrows-to-line': 57511,
  dolphin: 57704,
  'arrow-up-right': 57503,
  'circle-r': 57632,
  'cart-flatbed': 62580,
  'dolly-flatbed': 62580,
  'ban-smoking': 62797,
  'smoking-ban': 62797,
  'circle-sort-up': 57394,
  'sort-circle-up': 57394,
  terminal: 61728,
  'mobile-button': 61707,
  'house-medical-flag': 58644,
  'basket-shopping': 62097,
  'shopping-basket': 62097,
  tape: 62683,
  chestnut: 58358,
  'bus-simple': 62814,
  'bus-alt': 62814,
  eye: 61550,
  'face-sad-cry': 62899,
  'sad-cry': 62899,
  heat: 57356,
  'ticket-airline': 58010,
  'boot-heeled': 58175,
  'arrows-minimize': 57509,
  'compress-arrows': 57509,
  'audio-description': 62110,
  'person-military-to-person': 58700,
  'file-shield': 58608,
  hexagon: 62226,
  manhole: 57814,
  'user-slash': 62726,
  pen: 62212,
  'tower-observation': 58758,
  'floppy-disks': 57731,
  'toilet-paper-blank-under': 58015,
  'toilet-paper-reverse-alt': 58015,
  'file-code': 61897,
  signal: 61458,
  'signal-5': 61458,
  'signal-perfect': 61458,
  pump: 58434,
  bus: 61959,
  'heart-circle-xmark': 58625,
  'arrow-up-left-from-circle': 57502,
  'house-chimney': 58287,
  'home-lg': 58287,
  'window-maximize': 62160,
  dryer: 63585,
  'face-frown': 61721,
  frown: 61721,
  'chess-bishop-piece': 62523,
  'chess-bishop-alt': 62523,
  'shirt-tank-top': 58313,
  diploma: 62954,
  'scroll-ribbon': 62954,
  screencast: 57918,
  walker: 63537,
  prescription: 62897,
  shop: 62799,
  'store-alt': 62799,
  'floppy-disk': 61639,
  save: 61639,
  vihara: 63143,
  'face-kiss-closed-eyes': 58237,
  'scale-unbalanced': 62741,
  'balance-scale-left': 62741,
  'file-user': 63068,
  'user-police-tie': 58164,
  'face-tongue-money': 58269,
  'tennis-ball': 62558,
  'square-l': 57973,
  'sort-up': 61662,
  'sort-asc': 61662,
  'calendar-arrow-up': 57553,
  'calendar-upload': 57553,
  'comment-dots': 62637,
  commenting: 62637,
  'plant-wilt': 58794,
  scarf: 63425,
  'album-circle-plus': 58508,
  'user-nurse-hair-long': 58462,
  diamond: 61977,
  'square-left': 62289,
  'arrow-alt-square-left': 62289,
  'face-grin-squint': 62853,
  'grin-squint': 62853,
  'circle-ellipsis-vertical': 57611,
  'hand-holding-dollar': 62656,
  'hand-holding-usd': 62656,
  'grid-dividers': 58285,
  bacterium: 57434,
  'hand-pointer': 62042,
  'drum-steelpan': 62826,
  'hand-scissors': 62039,
  'hands-praying': 63108,
  'praying-hands': 63108,
  'face-pensive': 58244,
  'user-music': 63723,
  'arrow-rotate-right': 61470,
  'arrow-right-rotate': 61470,
  'arrow-rotate-forward': 61470,
  redo: 61470,
  'messages-dollar': 63058,
  'comments-alt-dollar': 63058,
  'sensor-on': 57387,
  balloon: 58083,
  biohazard: 63360,
  'chess-queen-piece': 62534,
  'chess-queen-alt': 62534,
  'location-crosshairs': 62977,
  location: 62977,
  'mars-double': 61991,
  'house-person-leave': 57359,
  'house-leave': 57359,
  'house-person-depart': 57359,
  'ruler-triangle': 63004,
  'card-club': 58345,
  'child-dress': 58780,
  'users-between-lines': 58769,
  'lungs-virus': 57447,
  'spinner-third': 62452,
  'face-grin-tears': 62856,
  'grin-tears': 62856,
  phone: 61589,
  'computer-mouse-scrollwheel': 63693,
  'mouse-alt': 63693,
  'calendar-xmark': 62067,
  'calendar-times': 62067,
  'child-reaching': 58781,
  'table-layout': 58000,
  narwhal: 63230,
  'ramp-loading': 62676,
  'calendar-circle-plus': 58480,
  toothbrush: 63029,
  'border-inner': 63566,
  'paw-claws': 63234,
  'kiwi-fruit': 58124,
  'traffic-light-slow': 63033,
  'rectangle-code': 58146,
  'head-side-virus': 57444,
  'keyboard-brightness': 57792,
  'books-medical': 63464,
  'lightbulb-slash': 63091,
  'house-blank': 58503,
  'home-blank': 58503,
  'square-5': 57946,
  'square-heart': 62664,
  'heart-square': 62664,
  puzzle: 58435,
  'user-gear': 62718,
  'user-cog': 62718,
  'pipe-circle-check': 58422,
  'arrow-up-1-9': 61795,
  'sort-numeric-up': 61795,
  'octagon-exclamation': 57860,
  'dial-low': 57693,
  'door-closed': 62762,
  'laptop-mobile': 63610,
  'phone-laptop': 63610,
  'conveyor-belt-boxes': 62575,
  'conveyor-belt-alt': 62575,
  'shield-virus': 57452,
  'starfighter-twin-ion-engine-advanced': 57998,
  'starfighter-alt-advanced': 57998,
  'dice-six': 62758,
  'starfighter-twin-ion-engine': 57400,
  'starfighter-alt': 57400,
  'rocket-launch': 57383,
  'mosquito-net': 58668,
  'vent-damper': 58469,
  'bridge-water': 58574,
  'ban-bug': 63481,
  debug: 63481,
  'person-booth': 63318,
  'text-width': 61493,
  'garage-car': 57354,
  'square-kanban': 58504,
  'hat-wizard': 63208,
  'pen-fancy': 62892,
  'coffee-pot': 57346,
  'mouse-field': 58792,
  'person-digging': 63582,
  digging: 63582,
  'shower-down': 57933,
  'shower-alt': 57933,
  'box-circle-check': 57540,
  brightness: 57545,
  'car-side-bolt': 58180,
  ornament: 63416,
  'phone-arrow-down-left': 57891,
  'phone-arrow-down': 57891,
  'phone-incoming': 57891,
  'cloud-word': 57656,
  'hand-fingers-crossed': 57763,
  trash: 61944,
  'gauge-simple': 63017,
  'gauge-simple-med': 63017,
  'tachometer-average': 63017,
  'arrow-down-small-big': 63629,
  'sort-size-down-alt': 63629,
  'book-medical': 63462,
  'face-melting': 58499,
  poo: 62206,
  'pen-clip-slash': 57871,
  'pen-alt-slash': 57871,
  'quote-right': 61710,
  'quote-right-alt': 61710,
  'scroll-old': 63247,
  guitars: 63679,
  'phone-xmark': 57895,
  hose: 58393,
  'clock-six': 58194,
  shirt: 62803,
  't-shirt': 62803,
  tshirt: 62803,
  'square-r': 57980,
  cubes: 61875,
  'envelope-open-dollar': 63063,
  divide: 62761,
  'sun-cloud': 63331,
  'lamp-floor': 57365,
  'square-7': 57948,
  'tenge-sign': 63447,
  tenge: 63447,
  headphones: 61477,
  'hands-holding': 62658,
  campfire: 63162,
  'circle-ampersand': 57592,
  snowflakes: 63439,
  'hands-clapping': 57768,
  republican: 63326,
  'leaf-maple': 63222,
  'arrow-left': 61536,
  'person-circle-xmark': 58691,
  ruler: 62789,
  'cup-straw-swoosh': 58212,
  'temperature-sun': 63338,
  'temperature-hot': 63338,
  'align-left': 61494,
  'dice-d6': 63185,
  restroom: 63421,
  'high-definition': 57774,
  'rectangle-hd': 57774,
  j: 74,
  galaxy: 57352,
  'users-viewfinder': 58773,
  'file-video': 61896,
  cherries: 57580,
  'up-right-from-square': 62301,
  'external-link-alt': 62301,
  'circle-sort': 57392,
  'sort-circle': 57392,
  'table-cells': 61450,
  th: 61450,
  'file-pdf': 61889,
  siren: 57389,
  'arrow-up-to-dotted-line': 57505,
  'image-landscape': 57781,
  landscape: 57781,
  'tank-water': 58450,
  'curling-stone': 62538,
  curling: 62538,
  'gamepad-modern': 58786,
  'gamepad-alt': 58786,
  'messages-question': 57831,
  'book-bible': 63047,
  bible: 63047,
  o: 79,
  'suitcase-medical': 61690,
  medkit: 61690,
  'briefcase-arrow-right': 58098,
  'expand-wide': 62240,
  'clock-eleven-thirty': 58184,
  rv: 63422,
  'user-secret': 61979,
  otter: 63232,
  dreidel: 63378,
  'person-dress': 61826,
  female: 61826,
  'comment-dollar': 63057,
  'business-time': 63050,
  'briefcase-clock': 63050,
  'flower-tulip': 63489,
  'people-pants-simple': 57882,
  'cloud-drizzle': 63288,
  'table-cells-large': 61449,
  'th-large': 61449,
  'book-tanakh': 63527,
  tanakh: 63527,
  'solar-system': 57391,
  'seal-question': 57923,
  'phone-volume': 62112,
  'volume-control-phone': 62112,
  'disc-drive': 63669,
  'hat-cowboy-side': 63681,
  'table-rows': 58002,
  rows: 58002,
  'location-exclamation': 62984,
  'map-marker-exclamation': 62984,
  'face-fearful': 58229,
  'clipboard-user': 63475,
  'bus-school': 62941,
  'film-slash': 57721,
  'square-arrow-down-right': 57954,
  'book-sparkles': 63160,
  'book-spells': 63160,
  'washing-machine': 63640,
  washer: 63640,
  child: 61870,
  'lira-sign': 61845,
  'user-visor': 57420,
  'file-plus-minus': 57719,
  'chess-clock-flip': 62526,
  'chess-clock-alt': 62526,
  satellite: 63423,
  'plane-lock': 58712,
  'steering-wheel': 63010,
  tag: 61483,
  stretcher: 63525,
  'book-section': 57537,
  'book-law': 57537,
  inboxes: 57787,
  'coffee-bean': 57662,
  'brackets-curly': 63466,
  'ellipsis-stroke-vertical': 62364,
  'ellipsis-v-alt': 62364,
  comment: 61557,
  'square-1': 57942,
  'cake-candles': 61949,
  'birthday-cake': 61949,
  cake: 61949,
  'head-side': 63209,
  envelope: 61664,
  'dolly-empty': 62579,
  'face-tissue': 58268,
  'angles-up': 61698,
  'angle-double-up': 61698,
  paperclip: 61638,
  'chart-line-down': 63053,
  'arrow-right-to-city': 58547,
  'lock-a': 58402,
  ribbon: 62678,
  lungs: 62980,
  'person-pinball': 57885,
  'arrow-up-9-1': 63623,
  'sort-numeric-up-alt': 63623,
  'apple-core': 57487,
  'circle-y': 57647,
  h6: 58387,
  'litecoin-sign': 57811,
  'circle-small': 57634,
  'border-none': 63568,
  'arrow-turn-down-left': 58081,
  'circle-nodes': 58594,
  'parachute-box': 62669,
  'message-medical': 63476,
  'comment-alt-medical': 63476,
  'rugby-ball': 58310,
  'comment-music': 63664,
  indent: 61500,
  'tree-deciduous': 62464,
  'tree-alt': 62464,
  'puzzle-piece-simple': 57905,
  'puzzle-piece-alt': 57905,
  'truck-field-un': 58766,
  'nfc-trash': 57853,
  hourglass: 62036,
  'hourglass-empty': 62036,
  mountain: 63228,
  'file-xmark': 62231,
  'file-times': 62231,
  'house-heart': 62665,
  'home-heart': 62665,
  'house-chimney-blank': 58288,
  'meter-bolt': 57833,
  'user-doctor': 61680,
  'user-md': 61680,
  'slash-back': 92,
  'circle-info': 61530,
  'info-circle': 61530,
  'fishing-rod': 58280,
  'hammer-crash': 58388,
  'message-heart': 58825,
  'cloud-meatball': 63291,
  'camera-polaroid': 63658,
  camera: 61488,
  'camera-alt': 61488,
  'square-virus': 58744,
  'cart-arrow-up': 58350,
  meteor: 63315,
  'car-on': 58589,
  sleigh: 63436,
  'arrow-down-1-9': 61794,
  'sort-numeric-asc': 61794,
  'sort-numeric-down': 61794,
  'buoy-mooring': 58806,
  'square-4': 57945,
  'hand-holding-droplet': 62657,
  'hand-holding-water': 62657,
  'tricycle-adult': 58820,
  waveform: 63729,
  water: 63347,
  'star-sharp-half-stroke': 57997,
  'star-sharp-half-alt': 57997,
  'nfc-signal': 57851,
  'plane-prop': 57899,
  'calendar-check': 62068,
  'clock-desk': 57652,
  'calendar-clock': 57554,
  'calendar-time': 57554,
  braille: 62113,
  'prescription-bottle-medical': 62598,
  'prescription-bottle-alt': 62598,
  'plate-utensils': 58427,
  'family-pants': 58114,
  'hose-reel': 58394,
  'house-window': 58291,
  landmark: 63087,
  truck: 61649,
  crosshairs: 61531,
  'cloud-rainbow': 63294,
  'person-cane': 58684,
  alien: 63733,
  tent: 58749,
  'vest-patches': 57478,
  'people-dress-simple': 57880,
  'check-double': 62816,
  'arrow-down-a-z': 61789,
  'sort-alpha-asc': 61789,
  'sort-alpha-down': 61789,
  'bowling-ball-pin': 57539,
  'bell-school-slash': 62934,
  'plus-large': 58782,
  'money-bill-wheat': 58666,
  'camera-viewfinder': 57562,
  screenshot: 57562,
  'message-music': 63663,
  'comment-alt-music': 63663,
  'car-building': 63577,
  'border-bottom-right': 63572,
  'border-style-alt': 63572,
  octagon: 62214,
  'comment-arrow-up-right': 57669,
  'octagon-divide': 57859,
  cookie: 62819,
  'arrow-rotate-left': 61666,
  'arrow-left-rotate': 61666,
  'arrow-rotate-back': 61666,
  'arrow-rotate-backward': 61666,
  undo: 61666,
  'tv-music': 63718,
  'hard-drive': 61600,
  hdd: 61600,
  reel: 57912,
  'face-grin-squint-tears': 62854,
  'grin-squint-tears': 62854,
  dumbbell: 62539,
  'rectangle-list': 61474,
  'list-alt': 61474,
  'tarp-droplet': 58748,
  'alarm-exclamation': 63555,
  'house-medical-circle-check': 58641,
  'traffic-cone': 63030,
  grate: 57747,
  'arrow-down-right': 57491,
  'person-skiing-nordic': 63434,
  'skiing-nordic': 63434,
  'calendar-plus': 62065,
  'person-from-portal': 57379,
  'portal-exit': 57379,
  'plane-arrival': 62895,
  'cowbell-circle-plus': 63668,
  'cowbell-more': 63668,
  'circle-left': 62297,
  'arrow-alt-circle-left': 62297,
  'distribute-spacing-vertical': 58214,
  'signal-bars-fair': 63122,
  'signal-alt-2': 63122,
  sportsball: 58443,
  'game-console-handheld-crank': 58809,
  'train-subway': 62009,
  subway: 62009,
  'chart-gantt': 57572,
  'face-smile-upside-down': 58261,
  'ball-pile': 63358,
  'badge-dollar': 63045,
  'money-bills-simple': 57844,
  'money-bills-alt': 57844,
  'list-timeline': 57809,
  'indian-rupee-sign': 57788,
  'indian-rupee': 57788,
  inr: 57788,
  'crop-simple': 62821,
  'crop-alt': 62821,
  'money-bill-1': 62417,
  'money-bill-alt': 62417,
  'left-long': 62218,
  'long-arrow-alt-left': 62218,
  'keyboard-down': 57794,
  'circle-up-right': 57641,
  'cloud-bolt-moon': 63341,
  'thunderstorm-moon': 63341,
  dna: 62577,
  'virus-slash': 57461,
  'bracket-round-right': 41,
  'circle-5': 57586,
  minus: 61544,
  subtract: 61544,
  'fire-flame': 63199,
  flame: 63199,
  'right-to-line': 62284,
  'arrow-alt-to-right': 62284,
  gif: 57744,
  chess: 62521,
  'trash-slash': 58035,
  'arrow-left-long': 61815,
  'long-arrow-left': 61815,
  'plug-circle-check': 58716,
  'font-case': 63590,
  'street-view': 61981,
  'arrow-down-left': 57489,
  'franc-sign': 57743,
  'flask-round-poison': 63200,
  'flask-poison': 63200,
  'volume-off': 61478,
  'book-circle-arrow-right': 57532,
  'chart-user': 63139,
  'user-chart': 63139,
  'hands-asl-interpreting': 62115,
  'american-sign-language-interpreting': 62115,
  'asl-interpreting': 62115,
  'hands-american-sign-language-interpreting': 62115,
  'presentation-screen': 63109,
  presentation: 63109,
  'circle-bolt': 57598,
  'face-smile-halo': 58255,
  'cart-circle-arrow-down': 58351,
  'house-person-return': 57361,
  'house-person-arrive': 57361,
  'house-return': 57361,
  'message-xmark': 62635,
  'comment-alt-times': 62635,
  'message-times': 62635,
  'file-certificate': 62963,
  'file-award': 62963,
  'user-doctor-hair-long': 58457,
  'camera-security': 63742,
  'camera-home': 63742,
  gear: 61459,
  cog: 61459,
  'droplet-slash': 62919,
  'tint-slash': 62919,
  'book-heart': 62617,
  mosque: 63096,
  duck: 63192,
  mosquito: 58667,
  'star-of-david': 63130,
  'flag-swallowtail': 63308,
  'flag-alt': 63308,
  'person-military-rifle': 58699,
  'car-garage': 62946,
  'cart-shopping': 61562,
  'shopping-cart': 61562,
  'book-font': 57535,
  'shield-plus': 57930,
  vials: 62611,
  'eye-dropper-full': 57714,
  'distribute-spacing-horizontal': 58213,
  'tablet-rugged': 62607,
  'temperature-snow': 63336,
  'temperature-frigid': 63336,
  moped: 58297,
  'face-smile-plus': 62905,
  'smile-plus': 62905,
  'radio-tuner': 63704,
  'radio-alt': 63704,
  'face-swear': 58265,
  'water-arrow-down': 63348,
  'water-lower': 63348,
  'scanner-touchscreen': 62602,
  'circle-7': 57588,
  'plug-circle-plus': 58719,
  'person-ski-jumping': 63431,
  'ski-jump': 63431,
  'place-of-worship': 63103,
  'water-arrow-up': 63349,
  'water-rise': 63349,
  'waveform-lines': 63730,
  'waveform-path': 63730,
  split: 57940,
  'film-canister': 63671,
  'film-cannister': 63671,
  'folder-xmark': 63071,
  'folder-times': 63071,
  'toilet-paper-blank': 63263,
  'toilet-paper-alt': 63263,
  'tablet-screen': 62460,
  'tablet-android-alt': 62460,
  'hexagon-vertical-nft-slanted': 58630,
  'folder-music': 57741,
  'display-medical': 57702,
  'desktop-medical': 57702,
  'share-all': 62311,
  peapod: 58140,
  'chess-clock': 62525,
  axe: 63154,
  'square-d': 57960,
  'grip-vertical': 62862,
  'mobile-signal-out': 57840,
  'arrow-turn-up': 61768,
  'level-up': 61768,
  u: 85,
  'arrow-up-from-dotted-line': 57499,
  'square-root-variable': 63128,
  'square-root-alt': 63128,
  'light-switch-on': 57369,
  'arrow-down-arrow-up': 63619,
  'sort-alt': 63619,
  raindrops: 63324,
  dash: 58372,
  'minus-large': 58372,
  clock: 61463,
  'clock-four': 61463,
  'input-numeric': 57789,
  'truck-tow': 58040,
  'backward-step': 61512,
  'step-backward': 61512,
  pallet: 62594,
  'car-bolt': 58177,
  'arrows-maximize': 62237,
  'expand-arrows': 62237,
  faucet: 57349,
  'cloud-sleet': 63297,
  'lamp-street': 57797,
  'list-radio': 57808,
  'pen-nib-slash': 58529,
  'baseball-bat-ball': 62514,
  'square-up-left': 57986,
  overline: 63606,
  s: 83,
  timeline: 58012,
  keyboard: 61724,
  'arrows-from-dotted-line': 57507,
  'usb-drive': 63721,
  ballot: 63282,
  'caret-down': 61655,
  'location-dot-slash': 62981,
  'map-marker-alt-slash': 62981,
  cards: 58349,
  'house-chimney-medical': 63474,
  'clinic-medical': 63474,
  'boxing-glove': 62520,
  'glove-boxing': 62520,
  'temperature-three-quarters': 62152,
  'temperature-3': 62152,
  'thermometer-3': 62152,
  'thermometer-three-quarters': 62152,
  'bell-school': 62933,
  'mobile-screen': 62415,
  'mobile-android-alt': 62415,
  'plane-up': 57901,
  'folder-heart': 57737,
  'circle-location-arrow': 62978,
  'location-circle': 62978,
  'face-head-bandage': 58234,
  'sushi-roll': 58507,
  'maki-roll': 58507,
  makizushi: 58507,
  'car-bump': 62944,
  'piggy-bank': 62675,
  racquet: 62554,
  'car-mirrors': 58179,
  'industry-windows': 62387,
  'industry-alt': 62387,
  'bolt-auto': 57526,
  'battery-half': 62018,
  'battery-3': 62018,
  'flux-capacitor': 63674,
  'mountain-city': 58670,
  coins: 62750,
  'honey-pot': 58392,
  olive: 58134,
  khanda: 63085,
  'filter-list': 57724,
  outlet: 57372,
  sliders: 61918,
  'sliders-h': 61918,
  cauldron: 63167,
  people: 57878,
  'folder-tree': 63490,
  'network-wired': 63231,
  croissant: 63478,
  'map-pin': 62070,
  hamsa: 63077,
  'cent-sign': 58357,
  'swords-laser': 57405,
  flask: 61635,
  'person-pregnant': 58142,
  'square-u': 57985,
  'wand-sparkles': 63275,
  router: 63706,
  'ellipsis-vertical': 61762,
  'ellipsis-v': 61762,
  'sword-laser-alt': 57404,
  ticket: 61765,
  'power-off': 61457,
  coin: 63580,
  'laptop-slash': 57799,
  'right-long': 62219,
  'long-arrow-alt-right': 62219,
  'circle-b': 57597,
  'person-dress-simple': 57884,
  'pipe-collar': 58423,
  'lights-holiday': 63410,
  citrus: 58100,
  'flag-usa': 63309,
  'laptop-file': 58653,
  tty: 61924,
  teletype: 61924,
  'chart-tree-map': 57578,
  'diagram-next': 58486,
  'person-rifle': 58702,
  'clock-five-thirty': 58186,
  'pipe-valve': 58425,
  'arrow-up-from-arc': 58548,
  'face-spiral-eyes': 58501,
  'compress-wide': 62246,
  'circle-phone-hangup': 57629,
  'phone-circle-down': 57629,
  'house-medical-circle-exclamation': 58642,
  badminton: 58170,
  'closed-captioning': 61962,
  'person-hiking': 63212,
  hiking: 63212,
  'right-from-line': 62279,
  'arrow-alt-from-left': 62279,
  'venus-double': 61990,
  images: 62210,
  calculator: 61932,
  shuttlecock: 62555,
  'user-hair': 58458,
  'eye-evil': 63195,
  'people-pulling': 58677,
  n: 78,
  garage: 57353,
  'cable-car': 63450,
  tram: 63450,
  'shovel-snow': 63427,
  'cloud-rain': 63293,
  'face-lying': 58238,
  sprinkler: 57397,
  'building-circle-xmark': 58580,
  'person-sledding': 63435,
  sledding: 63435,
  'game-console-handheld': 63675,
  ship: 61978,
  'clock-six-thirty': 58195,
  'battery-slash': 62327,
  'tugrik-sign': 58042,
  'arrows-down-to-line': 58552,
  download: 61465,
  shelves: 62592,
  inventory: 62592,
  'cloud-snow': 63298,
  'face-grin': 62848,
  grin: 62848,
  'delete-left': 62810,
  backspace: 62810,
  oven: 57373,
  'eye-dropper': 61947,
  'eye-dropper-empty': 61947,
  eyedropper: 61947,
  'comment-captions': 57670,
  'comments-question': 57678,
  scribble: 57919,
  'rotate-exclamation': 57916,
  'file-circle-check': 58784,
  glass: 63492,
  loader: 57812,
  forward: 61518,
  'user-pilot': 58048,
  mobile: 62414,
  'mobile-android': 62414,
  'mobile-phone': 62414,
  'code-pull-request-closed': 58361,
  'face-meh': 61722,
  meh: 61722,
  'align-center': 61495,
  'book-skull': 63159,
  'book-dead': 63159,
  'id-card': 62146,
  'drivers-license': 62146,
  'face-dotted': 58495,
  'face-worried': 58275,
  outdent: 61499,
  dedent: 61499,
  'heart-circle-exclamation': 58622,
  house: 61461,
  home: 61461,
  'home-alt': 61461,
  'home-lg-alt': 61461,
  'vector-circle': 58054,
  'car-circle-bolt': 58178,
  'calendar-week': 63364,
  'flying-disc': 58281,
  'laptop-medical': 63506,
  'square-down-right': 57964,
  b: 66,
  'seat-airline': 57924,
  'moon-over-sun': 63306,
  'eclipse-alt': 63306,
  pipe: 124,
  'file-medical': 62583,
  potato: 58432,
  'dice-one': 62757,
  'circle-a': 57591,
  'helmet-battle': 63211,
  butter: 58340,
  'blanket-fire': 58330,
  'kiwi-bird': 62773,
  castle: 57566,
  'golf-club': 62545,
  'arrow-right-arrow-left': 61676,
  exchange: 61676,
  'rotate-right': 62201,
  'redo-alt': 62201,
  'rotate-forward': 62201,
  utensils: 62183,
  cutlery: 62183,
  'arrow-up-wide-short': 61793,
  'sort-amount-up': 61793,
  balloons: 58084,
  'mill-sign': 57837,
  'bowl-rice': 58091,
  'timeline-arrow': 58013,
  skull: 62796,
  'game-board-simple': 63592,
  'game-board-alt': 63592,
  'circle-video': 57643,
  'video-circle': 57643,
  'chart-scatter-bubble': 57577,
  'house-turret': 57780,
  banana: 58085,
  'hand-holding-skull': 57764,
  'people-dress': 57879,
  loveseat: 62668,
  'couch-small': 62668,
  'tower-broadcast': 62745,
  'broadcast-tower': 62745,
  'truck-pickup': 63036,
  'block-quote': 57525,
  'up-long': 62220,
  'long-arrow-alt-up': 62220,
  stop: 61517,
  'code-merge': 62343,
  'money-check-dollar-pen': 63603,
  'money-check-edit-alt': 63603,
  'up-from-line': 62278,
  'arrow-alt-from-bottom': 62278,
  upload: 61587,
  hurricane: 63313,
  'people-pants': 57881,
  mound: 58669,
  windsock: 63351,
  'circle-half': 57616,
  'brake-warning': 57543,
  'toilet-portable': 58755,
  'compact-disc': 62751,
  'file-arrow-down': 62829,
  'file-download': 62829,
  'saxophone-fire': 63707,
  'sax-hot': 63707,
  'camera-web-slash': 63539,
  'webcam-slash': 63539,
  'folder-medical': 57740,
  'folder-gear': 57735,
  'folder-cog': 57735,
  'hand-wave': 57767,
  'arrow-up-arrow-down': 57497,
  'sort-up-down': 57497,
  caravan: 63743,
  'shield-cat': 58738,
  'message-slash': 62633,
  'comment-alt-slash': 62633,
  bolt: 61671,
  zap: 61671,
  'trash-can-check': 58025,
  'glass-water': 58612,
  'oil-well': 58674,
  'person-simple': 57888,
  vault: 58053,
  mars: 61986,
  toilet: 63448,
  'plane-circle-xmark': 58711,
  'yen-sign': 61783,
  cny: 61783,
  jpy: 61783,
  rmb: 61783,
  yen: 61783,
  notes: 57858,
  'ruble-sign': 61784,
  rouble: 61784,
  rub: 61784,
  ruble: 61784,
  'trash-undo': 63637,
  'trash-arrow-turn-left': 63637,
  'champagne-glass': 63390,
  'glass-champagne': 63390,
  'objects-align-center-horizontal': 58300,
  sun: 61829,
  'trash-can-slash': 58029,
  'trash-alt-slash': 58029,
  'screen-users': 63037,
  'users-class': 63037,
  guitar: 63398,
  'square-arrow-left': 62266,
  'arrow-square-left': 62266,
  'square-8': 57949,
  'face-smile-hearts': 58256,
  'brackets-square': 63465,
  brackets: 63465,
  'laptop-arrow-down': 57798,
  'hockey-stick-puck': 58286,
  'house-tree': 57779,
  'signal-fair': 63117,
  'signal-2': 63117,
  'face-laugh-wink': 62876,
  'laugh-wink': 62876,
  'circle-dollar': 62184,
  'dollar-circle': 62184,
  'usd-circle': 62184,
  'horse-head': 63403,
  'arrows-repeat': 62308,
  'repeat-alt': 62308,
  'bore-hole': 58563,
  industry: 62069,
  'image-polaroid': 63684,
  'wave-triangle': 63642,
  'circle-down': 62296,
  'arrow-alt-circle-down': 62296,
  grill: 58787,
  'arrows-turn-to-dots': 58561,
  'chart-mixed': 63043,
  analytics: 63043,
  'florin-sign': 57732,
  'arrow-down-short-wide': 63620,
  'sort-amount-desc': 63620,
  'sort-amount-down-alt': 63620,
  'less-than': 60,
  'display-code': 57701,
  'desktop-code': 57701,
  'face-drooling': 58226,
  'oil-temperature': 62996,
  'oil-temp': 62996,
  'square-question': 62205,
  'question-square': 62205,
  'air-conditioner': 63732,
  'angle-down': 61703,
  mountains: 63229,
  omega: 63098,
  'car-tunnel': 58590,
  'person-dolly-empty': 62673,
  'pan-food': 58411,
  'head-side-cough': 57441,
  'grip-lines': 63396,
  'thumbs-down': 61797,
  'user-lock': 62722,
  'arrow-right-long': 61816,
  'long-arrow-right': 61816,
  'tickets-airline': 58011,
  'anchor-circle-xmark': 58540,
  ellipsis: 61761,
  'ellipsis-h': 61761,
  'nfc-slash': 57852,
  'chess-pawn': 62531,
  'kit-medical': 62585,
  'first-aid': 62585,
  'grid-2-plus': 57751,
  bells: 63359,
  'person-through-window': 58793,
  toolbox: 62802,
  'envelope-dot': 57711,
  'envelope-badge': 57711,
  'hands-holding-circle': 58619,
  bug: 61832,
  'bowl-chopsticks': 58089,
  'credit-card': 61597,
  'credit-card-alt': 61597,
  'circle-s': 57633,
  'box-ballot': 63285,
  car: 61881,
  automobile: 61881,
  'hand-holding-hand': 58615,
  'user-tie-hair': 58463,
  'podium-star': 63320,
  'user-hair-mullet': 58460,
  'business-front': 58460,
  'party-back': 58460,
  'trian-balbot': 58460,
  'microphone-stand': 63691,
  'book-open-reader': 62938,
  'book-reader': 62938,
  'family-dress': 58113,
  'circle-x': 57646,
  cabin: 58477,
  'mountain-sun': 58671,
  'chart-simple-horizontal': 58484,
  'arrows-left-right-to-line': 58554,
  'hand-back-point-left': 57759,
  'message-dots': 62627,
  'comment-alt-dots': 62627,
  messaging: 62627,
  'file-heart': 57718,
  'beer-mug': 57523,
  'beer-foam': 57523,
  'dice-d20': 63183,
  drone: 63583,
  'truck-droplet': 58764,
  'file-circle-xmark': 58785,
  'temperature-arrow-up': 57408,
  'temperature-up': 57408,
  medal: 62882,
  bed: 62006,
  'book-copy': 57534,
  'square-h': 61693,
  'h-square': 61693,
  'square-c': 57958,
  'clock-two': 58202,
  'square-ellipsis-vertical': 57967,
  podcast: 62158,
  bee: 57522,
  'temperature-full': 62151,
  'temperature-4': 62151,
  'thermometer-4': 62151,
  'thermometer-full': 62151,
  bell: 61683,
  'candy-bar': 58344,
  'chocolate-bar': 58344,
  'xmark-large': 58779,
  pinata: 58307,
  'arrows-from-line': 57508,
  superscript: 61739,
  'bowl-spoon': 58336,
  'hexagon-check': 58390,
  'plug-circle-xmark': 58720,
  'star-of-life': 63009,
  'phone-slash': 62429,
  'traffic-light-stop': 63034,
  'paint-roller': 62890,
  'accent-grave': 96,
  'handshake-angle': 62660,
  'hands-helping': 62660,
  'circle-0': 57581,
  'dial-med-low': 57696,
  'location-dot': 62405,
  'map-marker-alt': 62405,
  crab: 58367,
  'box-open-full': 62620,
  'box-full': 62620,
  file: 61787,
  'greater-than': 62,
  quotes: 57908,
  pretzel: 58433,
  'person-swimming': 62916,
  swimmer: 62916,
  'arrow-down': 61539,
  'user-robot-xmarks': 58535,
  'message-quote': 57828,
  'comment-alt-quote': 57828,
  'candy-corn': 63165,
  'folder-magnifying-glass': 57739,
  'folder-search': 57739,
  notebook: 57857,
  droplet: 61507,
  tint: 61507,
  'bullseye-pointer': 63049,
  eraser: 61741,
  'hexagon-image': 58628,
  'earth-americas': 62845,
  earth: 62845,
  'earth-america': 62845,
  'globe-americas': 62845,
  'crate-apple': 63153,
  'apple-crate': 63153,
  'person-burst': 58683,
  'game-board': 63591,
  'hat-chef': 63595,
  'hand-back-point-right': 57761,
  dove: 62650,
  'snowflake-droplets': 58817,
  'battery-empty': 62020,
  'battery-0': 62020,
  'grid-4': 57752,
  socks: 63126,
  'face-sunglasses': 58264,
  inbox: 61468,
  'square-0': 57941,
  section: 58439,
  'square-this-way-up': 62623,
  'box-up': 62623,
  'gauge-high': 63013,
  'tachometer-alt': 63013,
  'tachometer-alt-fast': 63013,
  'square-ampersand': 57952,
  'envelope-open-text': 63064,
  'lamp-desk': 57364,
  hospital: 61688,
  'hospital-alt': 61688,
  'hospital-wide': 61688,
  'poll-people': 63321,
  'whiskey-glass-ice': 63393,
  'glass-whiskey-rocks': 63393,
  'wine-bottle': 63279,
  'chess-rook': 62535,
  'user-bounty-hunter': 58047,
  'bars-staggered': 62800,
  reorder: 62800,
  stream: 62800,
  'diagram-sankey': 57688,
  'cloud-hail-mixed': 63290,
  'circle-up-left': 57640,
  dharmachakra: 63061,
  'objects-align-left': 58302,
  'oil-can-drip': 57861,
  'face-smiling-hands': 58262,
  broccoli: 58338,
  'route-interstate': 63003,
  'ear-muffs': 63381,
  hotdog: 63503,
  'transporter-empty': 57414,
  'person-walking-with-cane': 62109,
  blind: 62109,
  'angle-90': 57485,
  'rectangle-terminal': 57910,
  kite: 63220,
  drum: 62825,
  scrubber: 62200,
  'ice-cream': 63504,
  'heart-circle-bolt': 58620,
  'fish-bones': 58116,
  'deer-rudolph': 63375,
  fax: 61868,
  paragraph: 61917,
  'head-side-heart': 57770,
  'square-e': 57965,
  'meter-fire': 57835,
  'cloud-hail': 63289,
  'check-to-slot': 63346,
  'vote-yea': 63346,
  'money-from-bracket': 58130,
  'star-half': 61577,
  'car-bus': 63578,
  speaker: 63711,
  timer: 58014,
  'boxes-stacked': 62568,
  boxes: 62568,
  'boxes-alt': 62568,
  'grill-hot': 58789,
  'ballot-check': 63283,
  link: 61633,
  chain: 61633,
  'ear-listen': 62114,
  'assistive-listening-systems': 62114,
  'file-minus': 62232,
  'tree-city': 58759,
  play: 61515,
  font: 61489,
  'cup-togo': 63173,
  'coffee-togo': 63173,
  'square-down-left': 57963,
  'burger-lettuce': 58339,
  'rupiah-sign': 57917,
  'magnifying-glass': 61442,
  search: 61442,
  'table-tennis-paddle-ball': 62557,
  'ping-pong-paddle-ball': 62557,
  'table-tennis': 62557,
  'person-dots-from-line': 62576,
  diagnoses: 62576,
  'chevrons-down': 62242,
  'chevron-double-down': 62242,
  'trash-can-arrow-up': 63530,
  'trash-restore-alt': 63530,
  'signal-good': 63118,
  'signal-3': 63118,
  'location-question': 62987,
  'map-marker-question': 62987,
  'floppy-disk-circle-xmark': 57729,
  'floppy-disk-times': 57729,
  'save-circle-xmark': 57729,
  'save-times': 57729,
  'naira-sign': 57846,
  peach: 57867,
  'taxi-bus': 58008,
  'bracket-curly': 123,
  'bracket-curly-left': 123,
  lobster: 58401,
  'cart-flatbed-empty': 62582,
  'dolly-flatbed-empty': 62582,
  colon: 58,
  'cart-arrow-down': 61976,
  wand: 63274,
  'walkie-talkie': 63727,
  'file-pen': 62236,
  'file-edit': 62236,
  receipt: 62787,
  'table-picnic': 58157,
  'square-pen': 61771,
  'pen-square': 61771,
  'pencil-square': 61771,
  'circle-microphone-lines': 57623,
  'microphone-circle-alt': 57623,
  'display-slash': 58106,
  'desktop-slash': 58106,
  'suitcase-rolling': 62913,
  'person-circle-exclamation': 58687,
  'transporter-2': 57412,
  'hands-holding-diamond': 62588,
  'hand-receiving': 62588,
  'money-bill-simple-wave': 57842,
  'chevron-down': 61560,
  'battery-full': 62016,
  battery: 62016,
  'battery-5': 62016,
  'bell-plus': 63561,
  'book-arrow-right': 57529,
  hospitals: 63502,
  club: 62247,
  'skull-crossbones': 63252,
  'droplet-degree': 63304,
  dewpoint: 63304,
  'code-compare': 57658,
  'list-ul': 61642,
  'list-dots': 61642,
  'hand-holding-magic': 63205,
  'watermelon-slice': 58167,
  'circle-ellipsis': 57610,
  'school-lock': 58735,
  'tower-cell': 58757,
  'sd-cards': 57920,
  'down-long': 62217,
  'long-arrow-alt-down': 62217,
  envelopes: 57712,
  'phone-office': 63101,
  'ranking-star': 58721,
  'chess-king': 62527,
  'nfc-pen': 57850,
  'person-harassing': 58697,
  'hat-winter': 63400,
  'brazilian-real-sign': 58476,
  'landmark-dome': 63314,
  'landmark-alt': 63314,
  'bone-break': 62936,
  'arrow-up': 61538,
  'down-from-dotted-line': 58375,
  tv: 62060,
  television: 62060,
  'tv-alt': 62060,
  'border-left': 63567,
  'circle-divide': 57606,
  shrimp: 58440,
  'list-check': 61614,
  tasks: 61614,
  'diagram-subtask': 58489,
  'jug-detergent': 58649,
  'circle-user': 62141,
  'user-circle': 62141,
  'square-y': 57991,
  'user-doctor-hair': 58456,
  'planet-ringed': 57376,
  mushroom: 58405,
  'user-shield': 62725,
  megaphone: 63093,
  'circle-exclamation-check': 57613,
  wind: 63278,
  'box-dollar': 62624,
  'box-usd': 62624,
  'car-burst': 62945,
  'car-crash': 62945,
  y: 89,
  'user-headset': 63533,
  'arrows-retweet': 62305,
  'retweet-alt': 62305,
  'person-snowboarding': 63438,
  snowboarding: 63438,
  'square-chevron-right': 62251,
  'chevron-square-right': 62251,
  'lacrosse-stick-ball': 58294,
  'truck-fast': 62603,
  'shipping-fast': 62603,
  'user-magnifying-glass': 58821,
  'star-sharp': 57995,
  'comment-heart': 58824,
  'circle-1': 57582,
  'circle-star': 57635,
  'star-circle': 57635,
  fish: 62840,
  'cloud-fog': 63310,
  fog: 63310,
  waffle: 58470,
  'music-note': 63695,
  'music-alt': 63695,
  'hexagon-exclamation': 58391,
  'cart-shopping-fast': 57564,
  'object-union': 58527,
  'user-graduate': 62721,
  starfighter: 57399,
  'circle-half-stroke': 61506,
  adjust: 61506,
  'arrow-right-long-to-line': 58325,
  'square-arrow-down': 62265,
  'arrow-square-down': 62265,
  'diamond-half-stroke': 58808,
  clapperboard: 57649,
  'square-chevron-left': 62250,
  'chevron-square-left': 62250,
  'phone-intercom': 58420,
  'link-horizontal': 57803,
  'chain-horizontal': 57803,
  mango: 58127,
  'music-note-slash': 63696,
  'music-alt-slash': 63696,
  'circle-radiation': 63418,
  'radiation-alt': 63418,
  'face-tongue-sweat': 58270,
  'globe-stand': 62966,
  baseball: 62515,
  'baseball-ball': 62515,
  'circle-p': 57626,
  'award-simple': 57515,
  'jet-fighter-up': 58648,
  'diagram-project': 62786,
  'project-diagram': 62786,
  pedestal: 57869,
  'chart-pyramid': 57574,
  sidebar: 57934,
  'snowman-head': 63387,
  'frosty-head': 63387,
  copy: 61637,
  'burger-glass': 57550,
  'volume-xmark': 63145,
  'volume-mute': 63145,
  'volume-times': 63145,
  'hand-sparkles': 57437,
  'bars-filter': 57517,
  'paintbrush-pencil': 57862,
  'party-bell': 58138,
  'user-vneck-hair': 58466,
  'jack-o-lantern': 62222,
  grip: 62861,
  'grip-horizontal': 62861,
  'share-from-square': 61773,
  'share-square': 61773,
  keynote: 63084,
  'child-combatant': 58592,
  'child-rifle': 58592,
  gun: 57755,
  'square-phone': 61592,
  'phone-square': 61592,
  plus: 43,
  add: 43,
  expand: 61541,
  computer: 58597,
  fort: 58502,
  'cloud-check': 58204,
  xmark: 61453,
  close: 61453,
  multiply: 61453,
  remove: 61453,
  times: 61453,
  'face-smirking': 58263,
  'arrows-up-down-left-right': 61511,
  arrows: 61511,
  'chalkboard-user': 62748,
  'chalkboard-teacher': 62748,
  rhombus: 57915,
  'claw-marks': 63170,
  'peso-sign': 57890,
  'face-smile-tongue': 58260,
  'cart-circle-xmark': 58356,
  'building-shield': 58584,
  'circle-phone-flip': 57628,
  'phone-circle-alt': 57628,
  baby: 63356,
  'users-line': 58770,
  'quote-left': 61709,
  'quote-left-alt': 61709,
  tractor: 63266,
  'key-skeleton': 63219,
  'trash-arrow-up': 63529,
  'trash-restore': 63529,
  'arrow-down-up-lock': 58544,
  'arrow-down-to-bracket': 57492,
  'lines-leaning': 58654,
  'square-q': 57979,
  'ruler-combined': 62790,
  symbols: 63598,
  'icons-alt': 63598,
  copyright: 61945,
  'highlighter-line': 57775,
  'bracket-square': 91,
  bracket: 91,
  'bracket-left': 91,
  'island-tropical': 63505,
  'island-tree-palm': 63505,
  'arrow-right-from-line': 62275,
  'arrow-from-left': 62275,
  h2: 62228,
  equals: 61,
  'cake-slice': 58341,
  shortcake: 58341,
  peanut: 58416,
  'wrench-simple': 58065,
  blender: 62743,
  teeth: 63022,
  'tally-2': 58005,
  'shekel-sign': 61963,
  ils: 61963,
  shekel: 61963,
  sheqel: 61963,
  'sheqel-sign': 61963,
  cars: 63579,
  'axe-battle': 63155,
  'user-hair-long': 58459,
  map: 62073,
  'file-circle-info': 58515,
  'face-disappointed': 58223,
  'lasso-sparkles': 57801,
  'clock-eleven': 58183,
  rocket: 61749,
  'siren-on': 57390,
  'clock-ten': 58196,
  'candle-holder': 63164,
  'video-arrow-down-left': 58056,
  'photo-film': 63612,
  'photo-video': 63612,
  'floppy-disk-circle-arrow-right': 57728,
  'save-circle-arrow-right': 57728,
  'folder-minus': 63069,
  'planet-moon': 57375,
  'face-eyes-xmarks': 58228,
  'chart-scatter': 63470,
  'display-arrow-down': 57700,
  store: 62798,
  'arrow-trend-up': 57496,
  'plug-circle-minus': 58718,
  'olive-branch': 58135,
  angle: 57484,
  'vacuum-robot': 57422,
  'sign-hanging': 62681,
  sign: 62681,
  'square-divide': 57962,
  'signal-stream-slash': 57936,
  'bezier-curve': 62811,
  'eye-dropper-half': 57715,
  'store-lock': 58534,
  'bell-slash': 61942,
  'cloud-bolt-sun': 63342,
  'thunderstorm-sun': 63342,
  'camera-slash': 57561,
  'comment-quote': 57676,
  tablet: 62459,
  'tablet-android': 62459,
  'school-flag': 58734,
  'message-code': 57823,
  'glass-half': 57746,
  'glass-half-empty': 57746,
  'glass-half-full': 57746,
  fill: 62837,
  'message-minus': 62631,
  'comment-alt-minus': 62631,
  'angle-up': 61702,
  'drumstick-bite': 63191,
  'link-horizontal-slash': 57804,
  'chain-horizontal-slash': 57804,
  'holly-berry': 63402,
  nose: 58813,
  'chevron-left': 61523,
  bacteria: 57433,
  clouds: 63300,
  'money-bill-simple': 57841,
  'hand-lizard': 62040,
  'table-pivot': 58001,
  'filter-slash': 57725,
  'trash-can-undo': 63638,
  'trash-can-arrow-turn-left': 63638,
  'trash-undo-alt': 63638,
  notdef: 57854,
  disease: 63482,
  'person-to-door': 58419,
  turntable: 63716,
  'briefcase-medical': 62569,
  genderless: 61997,
  'chevron-right': 61524,
  'signal-weak': 63116,
  'signal-1': 63116,
  'clock-five': 58185,
  retweet: 61561,
  'car-rear': 62942,
  'car-alt': 62942,
  'pump-soap': 57451,
  'computer-classic': 63665,
  frame: 58517,
  'video-slash': 62690,
  'battery-quarter': 62019,
  'battery-2': 62019,
  'ellipsis-stroke': 62363,
  'ellipsis-h-alt': 62363,
  radio: 63703,
  'baby-carriage': 63357,
  'carriage-baby': 63357,
  'face-expressionless': 58227,
  'down-to-dotted-line': 58376,
  'cloud-music': 63662,
  'traffic-light': 63031,
  'cloud-minus': 58205,
  thermometer: 62609,
  'shield-minus': 57929,
  'vr-cardboard': 63273,
  'car-tilt': 62949,
  'gauge-circle-minus': 58519,
  'brightness-low': 57546,
  'hand-middle-finger': 63494,
  percent: 37,
  percentage: 37,
  'truck-moving': 62687,
  'glass-water-droplet': 58613,
  'conveyor-belt': 62574,
  'location-check': 62982,
  'map-marker-check': 62982,
  'coin-vertical': 58365,
  display: 57699,
  'person-sign': 63319,
  'face-smile': 61720,
  smile: 61720,
  'phone-hangup': 57893,
  'signature-slash': 58315,
  thumbtack: 61581,
  'thumb-tack': 61581,
  'wheat-slash': 58169,
  trophy: 61585,
  'clouds-sun': 63302,
  'person-praying': 63107,
  pray: 63107,
  hammer: 63203,
  'face-vomit': 58272,
  speakers: 63712,
  'tty-answer': 58041,
  'teletype-answer': 58041,
  'mug-tea-saucer': 57845,
  'diagram-lean-canvas': 57686,
  alt: 57482,
  dial: 57691,
  'dial-med-high': 57691,
  'hand-peace': 62043,
  'circle-trash': 57638,
  'trash-circle': 57638,
  rotate: 62193,
  'sync-alt': 62193,
  'circle-quarters': 58360,
  spinner: 61712,
  'tower-control': 58018,
  'arrow-up-triangle-square': 63626,
  'sort-shapes-up': 63626,
  whale: 63276,
  robot: 62788,
  peace: 63100,
  'party-horn': 58139,
  gears: 61573,
  cogs: 61573,
  'sun-bright': 57999,
  'sun-alt': 57999,
  warehouse: 62612,
  'lock-keyhole-open': 62402,
  'lock-open-alt': 62402,
  'square-fragile': 62619,
  'box-fragile': 62619,
  'square-wine-glass-crack': 62619,
  'arrow-up-right-dots': 58551,
  'square-n': 57975,
  splotch: 62908,
  'face-grin-hearts': 62852,
  'grin-hearts': 62852,
  meter: 57832,
  mandolin: 63225,
  'dice-four': 62756,
  'sim-card': 63428,
  transgender: 61989,
  'transgender-alt': 61989,
  mercury: 61987,
  'up-from-bracket': 58768,
  'knife-kitchen': 63221,
  'border-right': 63570,
  'arrow-turn-down': 61769,
  'level-down': 61769,
  spade: 62196,
  'card-spade': 58348,
  'line-columns': 63600,
  'arrow-right-to-line': 62272,
  'arrow-to-right': 62272,
  'person-falling-burst': 58695,
  'flag-pennant': 62550,
  pennant: 62550,
  'conveyor-belt-empty': 57680,
  award: 62809,
  'ticket-simple': 62463,
  'ticket-alt': 62463,
  building: 61869,
  'angles-left': 61696,
  'angle-double-left': 61696,
  camcorder: 63656,
  'video-handheld': 63656,
  pancakes: 58413,
  'album-circle-user': 58509,
  qrcode: 61481,
  'dice-d10': 63181,
  fireplace: 63386,
  browser: 62334,
  'pen-paintbrush': 63000,
  'pencil-paintbrush': 63000,
  'fish-cooked': 63486,
  'chair-office': 63169,
  'nesting-dolls': 58298,
  'clock-rotate-left': 61914,
  history: 61914,
  trumpet: 63715,
  'face-grin-beam-sweat': 62851,
  'grin-beam-sweat': 62851,
  'fire-smoke': 63307,
  'phone-missed': 57894,
  'file-export': 62830,
  'arrow-right-from-file': 62830,
  shield: 61746,
  'shield-blank': 61746,
  'arrow-up-short-wide': 63621,
  'sort-amount-up-alt': 63621,
  'arrows-repeat-1': 62310,
  'repeat-1-alt': 62310,
  'gun-slash': 57756,
  avocado: 57514,
  binary: 58171,
  'glasses-round': 62965,
  'glasses-alt': 62965,
  'phone-plus': 62674,
  ditto: 34,
  'person-seat': 57886,
  'house-medical': 58290,
  'golf-ball-tee': 62544,
  'golf-ball': 62544,
  'circle-chevron-left': 61751,
  'chevron-circle-left': 61751,
  'house-chimney-window': 57357,
  scythe: 63248,
  'pen-nib': 62893,
  'ban-parking': 62998,
  'parking-circle-slash': 62998,
  'tent-arrow-turn-left': 58752,
  'face-diagonal-mouth': 58494,
  'diagram-cells': 58485,
  'cricket-bat-ball': 62537,
  cricket: 62537,
  tents: 58754,
  'wand-magic': 61648,
  magic: 61648,
  dog: 63187,
  'pen-line': 57874,
  'atom-simple': 62931,
  'atom-alt': 62931,
  ampersand: 38,
  carrot: 63367,
  'arrow-up-from-line': 62274,
  'arrow-from-bottom': 62274,
  moon: 61830,
  'pen-slash': 57875,
  'wine-glass-empty': 62926,
  'wine-glass-alt': 62926,
  'square-star': 57983,
  cheese: 63471,
  'send-backward': 63615,
  'yin-yang': 63149,
  music: 61441,
  'compass-slash': 62953,
  'clock-one': 58190,
  'file-music': 63670,
  'code-commit': 62342,
  'temperature-low': 63339,
  'person-biking': 63562,
  biking: 63562,
  skeleton: 63008,
  'circle-g': 57615,
  'circle-arrow-up-left': 57595,
  'coin-blank': 58363,
  broom: 62746,
  vacuum: 57421,
  'shield-heart': 58740,
  'card-heart': 58347,
  'lightbulb-cfl-on': 58791,
  melon: 58128,
  gopuram: 63076,
  'earth-oceania': 58491,
  'globe-oceania': 58491,
  'container-storage': 62647,
  'face-pouting': 58247,
  'square-xmark': 62163,
  'times-square': 62163,
  'xmark-square': 62163,
  'face-explode': 58110,
  'exploding-head': 58110,
  hashtag: 35,
  'up-right-and-down-left-from-center': 62500,
  'expand-alt': 62500,
  'oil-can': 62995,
  t: 84,
  'transformer-bolt': 58020,
  hippo: 63213,
  'chart-column': 57571,
  'cassette-vhs': 63724,
  vhs: 63724,
  infinity: 62772,
  'vial-circle-check': 58774,
  chimney: 63371,
  'object-intersect': 58525,
  'person-arrow-down-to-line': 58680,
  voicemail: 63639,
  'block-brick': 58331,
  'wall-brick': 58331,
  fan: 63587,
  'bags-shopping': 63559,
  'paragraph-left': 63608,
  'paragraph-rtl': 63608,
  'person-walking-luggage': 58708,
  'caravan-simple': 57344,
  'caravan-alt': 57344,
  turtle: 63270,
  'up-down': 62264,
  'arrows-alt-v': 62264,
  'cloud-moon-rain': 63292,
  'booth-curtain': 63284,
  calendar: 61747,
  'box-heart': 62621,
  trailer: 57409,
  'user-doctor-message': 63534,
  'user-md-chat': 63534,
  bahai: 63078,
  haykal: 63078,
  'amp-guitar': 63649,
  'sd-card': 63426,
  'volume-slash': 62178,
  'border-bottom': 63565,
  'wifi-weak': 63146,
  'wifi-1': 63146,
  dragon: 63189,
  'shoe-prints': 62795,
  'circle-plus': 61525,
  'plus-circle': 61525,
  'face-grin-tongue-wink': 62859,
  'grin-tongue-wink': 62859,
  'hand-holding': 62653,
  'plug-circle-exclamation': 58717,
  'link-slash': 61735,
  'chain-broken': 61735,
  'chain-slash': 61735,
  unlink: 61735,
  clone: 62029,
  'person-walking-arrow-loop-left': 58705,
  'arrow-up-z-a': 63618,
  'sort-alpha-up-alt': 63618,
  'fire-flame-curved': 63460,
  'fire-alt': 63460,
  tornado: 63343,
  'file-circle-plus': 58516,
  'delete-right': 57684,
  'book-quran': 63111,
  quran: 63111,
  'circle-quarter': 57631,
  anchor: 61757,
  'border-all': 63564,
  function: 63073,
  'face-angry': 62806,
  angry: 62806,
  'people-simple': 57883,
  'cookie-bite': 62820,
  'arrow-trend-down': 57495,
  rss: 61598,
  feed: 61598,
  'face-monocle': 58240,
  'draw-polygon': 62958,
  'scale-balanced': 62030,
  'balance-scale': 62030,
  'calendar-lines': 57557,
  'calendar-note': 57557,
  'arrow-down-big-small': 63628,
  'sort-size-down': 63628,
  'gauge-simple-high': 63018,
  tachometer: 63018,
  'tachometer-fast': 63018,
  'do-not-enter': 62956,
  shower: 62156,
  'dice-d8': 63186,
  desktop: 62352,
  'desktop-alt': 62352,
  m: 77,
  'grip-dots-vertical': 58385,
  'face-viewfinder': 58111,
  'soft-serve': 58368,
  creemee: 58368,
  h5: 58386,
  'hand-back-point-down': 57758,
  'table-list': 61451,
  'th-list': 61451,
  'comment-sms': 63437,
  sms: 63437,
  rectangle: 62202,
  'rectangle-landscape': 62202,
  'clipboard-list-check': 63287,
  turkey: 63269,
  book: 61485,
  'user-plus': 62004,
  'ice-skate': 63404,
  check: 61452,
  'battery-three-quarters': 62017,
  'battery-4': 62017,
  tomato: 58160,
  'sword-laser': 57403,
  'house-circle-check': 58633,
  buildings: 57548,
  'angle-left': 61700,
  'cart-flatbed-boxes': 62581,
  'dolly-flatbed-alt': 62581,
  'diagram-successor': 58490,
  'truck-arrow-right': 58763,
  'square-w': 57989,
  'arrows-split-up-and-left': 58556,
  lamp: 62666,
  airplay: 57481,
  'hand-fist': 63198,
  'fist-raised': 63198,
  'shield-quartered': 58741,
  'slash-forward': 47,
  'location-pen': 62983,
  'map-marker-edit': 62983,
  'cloud-moon': 63171,
  'pot-food': 58431,
  briefcase: 61617,
  'person-falling': 58694,
  'image-portrait': 62432,
  portrait: 62432,
  'user-tag': 62727,
  rug: 58729,
  'print-slash': 63110,
  'earth-europe': 63394,
  'globe-europe': 63394,
  'cart-flatbed-suitcase': 62877,
  'luggage-cart': 62877,
  'hand-back-point-ribbon': 57760,
  'rectangle-xmark': 62480,
  'rectangle-times': 62480,
  'times-rectangle': 62480,
  'window-close': 62480,
  'tire-rugged': 63028,
  'lightbulb-dollar': 63088,
  cowbell: 63667,
  'baht-sign': 57516,
  corner: 58366,
  'chevrons-right': 62244,
  'chevron-double-right': 62244,
  'book-open': 62744,
  'book-journal-whills': 63082,
  'journal-whills': 63082,
  inhaler: 62969,
  handcuffs: 58616,
  snake: 63254,
  'triangle-exclamation': 61553,
  'exclamation-triangle': 61553,
  warning: 61553,
  'note-medical': 57856,
  database: 61888,
  'down-left': 57706,
  share: 61540,
  'arrow-turn-right': 61540,
  'mail-forward': 61540,
  'face-thinking': 58267,
  'turn-down-right': 58453,
  'bottle-droplet': 58564,
  'mask-face': 57815,
  'hill-rockslide': 58632,
  'scanner-keyboard': 62601,
  'circle-o': 57625,
  'grid-horizontal': 58119,
  'message-dollar': 63056,
  'comment-alt-dollar': 63056,
  'right-left': 62306,
  'exchange-alt': 62306,
  'columns-3': 58209,
  'paper-plane': 61912,
  'road-circle-exclamation': 58725,
  dungeon: 63193,
  'hand-holding-box': 62587,
  'input-text': 57791,
  'window-flip': 62479,
  'window-alt': 62479,
  'align-right': 61496,
  'scanner-gun': 62600,
  scanner: 62600,
  tire: 63025,
  engine: 57710,
  'money-bill-1-wave': 62779,
  'money-bill-wave-alt': 62779,
  'life-ring': 61901,
  hands: 62119,
  'sign-language': 62119,
  signing: 62119,
  'circle-caret-right': 62256,
  'caret-circle-right': 62256,
  wheat: 63277,
  'file-spreadsheet': 63067,
  'audio-description-slash': 57512,
  'calendar-day': 63363,
  'water-ladder': 62917,
  'ladder-water': 62917,
  'swimming-pool': 62917,
  'arrows-up-down': 61565,
  'arrows-v': 61565,
  'chess-pawn-piece': 62532,
  'chess-pawn-alt': 62532,
  'face-grimace': 62847,
  grimace: 62847,
  'wheelchair-move': 58062,
  'wheelchair-alt': 58062,
  'turn-down': 62398,
  'level-down-alt': 62398,
  'square-s': 57981,
  'rectangle-barcode': 62563,
  'barcode-alt': 62563,
  'person-walking-arrow-right': 58706,
  'square-envelope': 61849,
  'envelope-square': 61849,
  dice: 62754,
  unicorn: 63271,
  'bowling-ball': 62518,
  pompebled: 58429,
  brain: 62940,
  'watch-smart': 58060,
  'book-user': 63463,
  'sensor-cloud': 57388,
  'sensor-smoke': 57388,
  'clapperboard-play': 57650,
  bandage: 62562,
  'band-aid': 62562,
  'calendar-minus': 62066,
  'circle-xmark': 61527,
  'times-circle': 61527,
  'xmark-circle': 61527,
  'circle-4': 57585,
  gifts: 63388,
  'album-collection': 63648,
  hotel: 62868,
  'earth-asia': 62846,
  'globe-asia': 62846,
  'id-card-clip': 62591,
  'id-card-alt': 62591,
  'magnifying-glass-plus': 61454,
  'search-plus': 61454,
  'thumbs-up': 61796,
  'cloud-showers': 63295,
  'user-clock': 62717,
  onion: 58407,
  'clock-twelve-thirty': 58201,
  'arrow-down-to-dotted-line': 57493,
  'hand-dots': 62561,
  allergies: 62561,
  'file-invoice': 62832,
  'window-minimize': 62161,
  'rectangle-wide': 62204,
  'comment-arrow-up': 57668,
  garlic: 58382,
  'mug-saucer': 61684,
  coffee: 61684,
  brush: 62813,
  'tree-decorated': 63452,
  mask: 63226,
  'calendar-heart': 57555,
  'magnifying-glass-minus': 61456,
  'search-minus': 61456,
  flower: 63487,
  'ruler-vertical': 62792,
  'user-large': 62470,
  'user-alt': 62470,
  'starship-freighter': 57402,
  'train-tram': 58804,
  'bridge-suspension': 58573,
  'trash-check': 58031,
  'user-nurse': 63535,
  boombox: 63653,
  syringe: 62606,
  'cloud-sun': 63172,
  'shield-exclamation': 57927,
  'stopwatch-20': 57455,
  'square-full': 62556,
  'grip-dots': 58384,
  'comment-exclamation': 62639,
  'pen-swirl': 57876,
  falafel: 58378,
  'circle-2': 57583,
  magnet: 61558,
  jar: 58646,
  gramophone: 63677,
  'dice-d12': 63182,
  'note-sticky': 62025,
  'sticky-note': 62025,
  down: 62292,
  'arrow-alt-down': 62292,
  'hundred-points': 58396,
  'paperclip-vertical': 58306,
  'wind-warning': 63350,
  'wind-circle-exclamation': 63350,
  'location-pin-slash': 62988,
  'map-marker-slash': 62988,
  'face-sad-sweat': 58250,
  'bug-slash': 58512,
  cupcake: 58370,
  'light-switch-off': 57368,
  'toggle-large-off': 58800,
  'pen-fancy-slash': 57872,
  'truck-container': 62684,
  boot: 63362,
  'arrow-up-from-water-pump': 58550,
  'file-check': 62230,
  bone: 62935,
  'cards-blank': 58591,
  'circle-3': 57584,
  'bench-tree': 58087,
  'keyboard-brightness-low': 57793,
  'ski-boot-ski': 58317,
  'brain-circuit': 57542,
  'user-injured': 63272,
  'block-brick-fire': 58332,
  firewall: 58332,
  'face-sad-tear': 62900,
  'sad-tear': 62900,
  plane: 61554,
  'tent-arrows-down': 58753,
  exclamation: 33,
  'arrows-spin': 58555,
  'face-smile-relaxed': 58258,
  'comment-xmark': 62645,
  'comment-times': 62645,
  print: 61487,
  'turkish-lira-sign': 58043,
  try: 58043,
  'turkish-lira': 58043,
  'face-nose-steam': 58242,
  'circle-waveform-lines': 57645,
  'waveform-circle': 57645,
  'dollar-sign': 36,
  dollar: 36,
  usd: 36,
  'ferris-wheel': 57716,
  'computer-speaker': 63666,
  'skull-cow': 63710,
  x: 88,
  'magnifying-glass-dollar': 63112,
  'search-dollar': 63112,
  'users-gear': 62729,
  'users-cog': 62729,
  'person-military-pointing': 58698,
  'building-columns': 61852,
  bank: 61852,
  institution: 61852,
  museum: 61852,
  university: 61852,
  'circle-t': 57636,
  sack: 63516,
  'grid-2': 57750,
  'camera-cctv': 63660,
  cctv: 63660,
  umbrella: 61673,
  trowel: 58761,
  'horizontal-rule': 63596,
  'bed-front': 63735,
  'bed-alt': 63735,
  d: 68,
  stapler: 58799,
  'masks-theater': 63024,
  'theater-masks': 63024,
  'kip-sign': 57796,
  'face-woozy': 58274,
  'cloud-question': 58514,
  pineapple: 58143,
  'hand-point-left': 61605,
  'gallery-thumbnails': 58282,
  'circle-j': 57618,
  eyes: 58215,
  'handshake-simple': 62662,
  'handshake-alt': 62662,
  'page-caret-up': 58410,
  'file-caret-up': 58410,
  'jet-fighter': 61691,
  'fighter-jet': 61691,
  comet: 57347,
  'square-share-nodes': 61921,
  'share-alt-square': 61921,
  'shield-keyhole': 57928,
  barcode: 61482,
  'plus-minus': 58428,
  'square-sliders-vertical': 62450,
  'sliders-v-square': 62450,
  video: 61501,
  'video-camera': 61501,
  'message-middle': 57825,
  'comment-middle-alt': 57825,
  'graduation-cap': 61853,
  'mortar-board': 61853,
  'hand-holding-medical': 57436,
  'person-circle-check': 58686,
  'square-z': 57992,
  'message-text': 57830,
  'comment-alt-text': 57830,
  'turn-up': 62399,
  'level-up-alt': 62399,
  monero: 62416,
  hooli: 62503,
  yelp: 61929,
  'cc-visa': 61936,
  lastfm: 61954,
  shopware: 62901,
  'creative-commons-nc': 62696,
  aws: 62325,
  redhat: 63420,
  yoast: 62129,
  cloudflare: 57469,
  ups: 63456,
  wpexplorer: 62174,
  dyalog: 62361,
  bity: 62330,
  stackpath: 63554,
  buysellads: 61965,
  'first-order': 62128,
  modx: 62085,
  guilded: 57470,
  vnv: 62475,
  'square-js': 62393,
  'js-square': 62393,
  microsoft: 62410,
  qq: 61910,
  orcid: 63698,
  java: 62692,
  invision: 63408,
  'creative-commons-pd-alt': 62701,
  centercode: 62336,
  'glide-g': 62118,
  drupal: 61865,
  'hire-a-helper': 62384,
  'creative-commons-by': 62695,
  unity: 57417,
  whmcs: 62477,
  rocketchat: 62440,
  vk: 61833,
  untappd: 62469,
  mailchimp: 62878,
  'css3-alt': 62347,
  'square-reddit': 61858,
  'reddit-square': 61858,
  'vimeo-v': 62077,
  contao: 62061,
  'square-font-awesome': 58797,
  deskpro: 62351,
  sistrix: 62446,
  'square-instagram': 57429,
  'instagram-square': 57429,
  'battle-net': 63541,
  'the-red-yeti': 63133,
  'square-hacker-news': 62383,
  'hacker-news-square': 62383,
  edge: 62082,
  napster: 62418,
  'square-snapchat': 62125,
  'snapchat-square': 62125,
  'google-plus-g': 61653,
  artstation: 63354,
  markdown: 62991,
  sourcetree: 63443,
  'google-plus': 62131,
  diaspora: 63377,
  foursquare: 61824,
  'stack-overflow': 61804,
  'github-alt': 61715,
  'phoenix-squadron': 62737,
  pagelines: 61836,
  algolia: 62316,
  'red-river': 62435,
  'creative-commons-sa': 62703,
  safari: 62055,
  google: 61856,
  'square-font-awesome-stroke': 62300,
  'font-awesome-alt': 62300,
  atlassian: 63355,
  'linkedin-in': 61665,
  'digital-ocean': 62353,
  nimblr: 62888,
  chromecast: 63544,
  evernote: 63545,
  'hacker-news': 61908,
  'creative-commons-sampling': 62704,
  adversal: 62314,
  'creative-commons': 62046,
  'watchman-monitoring': 57479,
  fonticons: 62080,
  weixin: 61911,
  shirtsinbulk: 61972,
  codepen: 61899,
  'git-alt': 63553,
  lyft: 62403,
  rev: 62898,
  windows: 61818,
  'wizards-of-the-coast': 63280,
  'square-viadeo': 62122,
  'viadeo-square': 62122,
  meetup: 62176,
  centos: 63369,
  adn: 61808,
  cloudsmith: 62340,
  'pied-piper-alt': 61864,
  'square-dribbble': 62359,
  'dribbble-square': 62359,
  codiepie: 62084,
  node: 62489,
  mix: 62411,
  steam: 61878,
  'cc-apple-pay': 62486,
  scribd: 62090,
  openid: 61851,
  instalod: 57473,
  expeditedssl: 62014,
  sellcast: 62170,
  'square-twitter': 61569,
  'twitter-square': 61569,
  'r-project': 62711,
  delicious: 61861,
  freebsd: 62372,
  vuejs: 62495,
  accusoft: 62313,
  ioxhost: 61960,
  'fonticons-fi': 62370,
  'app-store': 62319,
  'cc-mastercard': 61937,
  'itunes-note': 62389,
  golang: 58383,
  kickstarter: 62395,
  grav: 62166,
  weibo: 61834,
  uncharted: 57476,
  firstdraft: 62369,
  'square-youtube': 62513,
  'youtube-square': 62513,
  'wikipedia-w': 62054,
  wpressr: 62436,
  rendact: 62436,
  angellist: 61961,
  'galactic-republic': 62732,
  'nfc-directional': 58672,
  skype: 61822,
  joget: 62391,
  fedora: 63384,
  'stripe-s': 62506,
  meta: 58523,
  laravel: 62397,
  hotjar: 62385,
  'bluetooth-b': 62100,
  'sticker-mule': 62455,
  'creative-commons-zero': 62707,
  hips: 62546,
  behance: 61876,
  reddit: 61857,
  discord: 62354,
  chrome: 62056,
  'app-store-ios': 62320,
  'cc-discover': 61938,
  wpbeginner: 62103,
  confluence: 63373,
  mdb: 63690,
  dochub: 62356,
  'accessible-icon': 62312,
  ebay: 62708,
  amazon: 62064,
  unsplash: 57468,
  yarn: 63459,
  'square-steam': 61879,
  'steam-square': 61879,
  '500px': 62062,
  'square-vimeo': 61844,
  'vimeo-square': 61844,
  asymmetrik: 62322,
  'font-awesome': 62132,
  'font-awesome-flag': 62132,
  'font-awesome-logo-full': 62132,
  gratipay: 61828,
  apple: 61817,
  hive: 57471,
  gitkraken: 62374,
  keybase: 62709,
  'apple-pay': 62485,
  padlet: 58528,
  'amazon-pay': 62508,
  'square-github': 61586,
  'github-square': 61586,
  stumbleupon: 61860,
  fedex: 63383,
  'phoenix-framework': 62428,
  shopify: 57431,
  neos: 62994,
  hackerrank: 62967,
  researchgate: 62712,
  swift: 63713,
  angular: 62496,
  speakap: 62451,
  angrycreative: 62318,
  'y-combinator': 62011,
  empire: 61905,
  envira: 62105,
  'square-gitlab': 58798,
  'gitlab-square': 58798,
  studiovinari: 62456,
  'pied-piper': 62126,
  wordpress: 61850,
  'product-hunt': 62088,
  firefox: 62057,
  linode: 62136,
  goodreads: 62376,
  'square-odnoklassniki': 62052,
  'odnoklassniki-square': 62052,
  jsfiddle: 61900,
  sith: 62738,
  themeisle: 62130,
  page4: 62423,
  hashnode: 58521,
  react: 62491,
  'cc-paypal': 61940,
  squarespace: 62910,
  'cc-stripe': 61941,
  'creative-commons-share': 62706,
  bitcoin: 62329,
  keycdn: 62394,
  opera: 62058,
  'itch-io': 63546,
  umbraco: 63720,
  'galactic-senate': 62733,
  ubuntu: 63455,
  draft2digital: 62358,
  stripe: 62505,
  houzz: 62076,
  gg: 62048,
  dhl: 63376,
  'square-pinterest': 61651,
  'pinterest-square': 61651,
  xing: 61800,
  blackberry: 62331,
  'creative-commons-pd': 62700,
  playstation: 62431,
  quinscape: 62553,
  less: 62493,
  'blogger-b': 62333,
  opencart: 62013,
  vine: 61898,
  paypal: 61933,
  gitlab: 62102,
  typo3: 62507,
  'reddit-alien': 62081,
  yahoo: 61854,
  dailymotion: 57426,
  affiliatetheme: 62315,
  'pied-piper-pp': 61863,
  bootstrap: 63542,
  odnoklassniki: 62051,
  'nfc-symbol': 58673,
  ethereum: 62510,
  'speaker-deck': 63548,
  'creative-commons-nc-eu': 62697,
  patreon: 62425,
  avianex: 62324,
  ello: 62961,
  gofore: 62375,
  bimobject: 62328,
  'facebook-f': 62366,
  'square-google-plus': 61652,
  'google-plus-square': 61652,
  mandalorian: 62735,
  'first-order-alt': 62730,
  osi: 62490,
  'google-wallet': 61934,
  'd-and-d-beyond': 63178,
  periscope: 62426,
  fulcrum: 62731,
  cloudscale: 62339,
  forumbee: 61969,
  mizuni: 62412,
  schlix: 62442,
  'square-xing': 61801,
  'xing-square': 61801,
  bandcamp: 62165,
  wpforms: 62104,
  cloudversify: 62341,
  usps: 63457,
  megaport: 62883,
  magento: 62404,
  spotify: 61884,
  'optin-monster': 62012,
  fly: 62487,
  aviato: 62497,
  itunes: 62388,
  cuttlefish: 62348,
  blogger: 62332,
  flickr: 61806,
  viber: 62473,
  soundcloud: 61886,
  digg: 61862,
  'tencent-weibo': 61909,
  symfony: 63549,
  maxcdn: 61750,
  etsy: 62167,
  'facebook-messenger': 62367,
  audible: 62323,
  'think-peaks': 63281,
  bilibili: 58329,
  erlang: 62365,
  'cotton-bureau': 63646,
  dashcube: 61968,
  '42-group': 57472,
  innosoft: 57472,
  'stack-exchange': 61837,
  elementor: 62512,
  'square-pied-piper': 57374,
  'pied-piper-square': 57374,
  'creative-commons-nd': 62699,
  palfed: 62424,
  superpowers: 62173,
  resolving: 62439,
  xbox: 62482,
  searchengin: 62443,
  tiktok: 57467,
  'square-facebook': 61570,
  'facebook-square': 61570,
  renren: 61835,
  linux: 61820,
  glide: 62117,
  linkedin: 61580,
  hubspot: 62386,
  deploydog: 62350,
  twitch: 61928,
  ravelry: 62169,
  mixer: 57430,
  'square-lastfm': 61955,
  'lastfm-square': 61955,
  vimeo: 62474,
  mendeley: 63411,
  uniregistry: 62468,
  figma: 63385,
  'creative-commons-remix': 62702,
  'cc-amazon-pay': 62509,
  dropbox: 61803,
  instagram: 61805,
  cmplid: 58208,
  facebook: 61594,
  gripfire: 62380,
  'jedi-order': 62734,
  uikit: 62467,
  'fort-awesome-alt': 62371,
  phabricator: 62427,
  ussunnah: 62471,
  earlybirds: 62362,
  'trade-federation': 62739,
  autoprefixer: 62492,
  whatsapp: 62002,
  slideshare: 61927,
  'google-play': 62379,
  viadeo: 62121,
  line: 62400,
  'google-drive': 62378,
  servicestack: 62444,
  simplybuilt: 61973,
  bitbucket: 61809,
  imdb: 62168,
  deezer: 57463,
  'raspberry-pi': 63419,
  jira: 63409,
  docker: 62357,
  screenpal: 58736,
  bluetooth: 62099,
  gitter: 62502,
  'd-and-d': 62349,
  microblog: 57370,
  'cc-diners-club': 62028,
  'gg-circle': 62049,
  'pied-piper-hat': 62693,
  'kickstarter-k': 62396,
  yandex: 62483,
  readme: 62677,
  html5: 61755,
  sellsy: 61971,
  sass: 62494,
  wirsindhandwerk: 58064,
  wsh: 58064,
  buromobelexperte: 62335,
  salesforce: 63547,
  'octopus-deploy': 57474,
  medapps: 62406,
  ns8: 62421,
  'pinterest-p': 62001,
  apper: 62321,
  'fort-awesome': 62086,
  waze: 63551,
  'cc-jcb': 62027,
  snapchat: 62123,
  'snapchat-ghost': 62123,
  'fantasy-flight-games': 63196,
  rust: 57466,
  wix: 62927,
  'square-behance': 61877,
  'behance-square': 61877,
  supple: 62457,
  rebel: 61904,
  css3: 61756,
  staylinked: 62453,
  kaggle: 62970,
  'space-awesome': 58796,
  deviantart: 61885,
  cpanel: 62344,
  'goodreads-g': 62377,
  'square-git': 61906,
  'git-square': 61906,
  'square-tumblr': 61812,
  'tumblr-square': 61812,
  trello: 61825,
  'creative-commons-nc-jp': 62698,
  'get-pocket': 62053,
  perbyte: 57475,
  grunt: 62381,
  weebly: 62924,
  connectdevelop: 61966,
  leanpub: 61970,
  'black-tie': 62078,
  themeco: 62918,
  python: 62434,
  android: 61819,
  bots: 58176,
  'free-code-camp': 62149,
  hornbill: 62866,
  js: 62392,
  ideal: 57363,
  git: 61907,
  dev: 63180,
  sketch: 63430,
  'yandex-international': 62484,
  'cc-amex': 61939,
  uber: 62466,
  github: 61595,
  php: 62551,
  alipay: 63042,
  youtube: 61799,
  skyatlas: 61974,
  'firefox-browser': 57351,
  replyd: 62438,
  suse: 63446,
  jenkins: 62390,
  twitter: 61593,
  rockrms: 62441,
  pinterest: 61650,
  buffer: 63543,
  npm: 62420,
  yammer: 63552,
  btc: 61786,
  dribbble: 61821,
  'stumbleupon-circle': 61859,
  'internet-explorer': 62059,
  stubber: 58823,
  telegram: 62150,
  'telegram-plane': 62150,
  'old-republic': 62736,
  odysee: 58822,
  'square-whatsapp': 62476,
  'whatsapp-square': 62476,
  'node-js': 62419,
  'edge-legacy': 57464,
  slack: 61848,
  'slack-hash': 61848,
  medrt: 62408,
  usb: 62087,
  tumblr: 61811,
  vaadin: 62472,
  quora: 62148,
  reacteurope: 63325,
  medium: 62010,
  'medium-m': 62010,
  amilia: 62317,
  mixcloud: 62089,
  flipboard: 62541,
  viacoin: 62007,
  'critical-role': 63177,
  sitrox: 58442,
  discourse: 62355,
  joomla: 61866,
  mastodon: 62710,
  airbnb: 63540,
  'wolf-pack-battalion': 62740,
  'buy-n-large': 63654,
  gulp: 62382,
  'creative-commons-sampling-plus': 62705,
  strava: 62504,
  ember: 62499,
  'canadian-maple-leaf': 63365,
  teamspeak: 62713,
  pushed: 62433,
  'wordpress-simple': 62481,
  nutritionix: 62422,
  wodu: 57480,
  'google-pay': 57465,
  intercom: 63407,
  zhihu: 63039,
  korvue: 62511,
  pix: 58426,
  'steam-symbol': 62454,
};

export type FontAwesomeIconName = keyof typeof FontAwesomeGlyphs;

export default FontAwesomeGlyphs;
